// src/data/homebrewSets.ts

// Community Homebrew Templates
//
// How to add a new homebrew pack:
// 1. User sends you their exported .json file via Discord.
// 2. Open the file and copy EVERYTHING inside (the whole object with "modelTemplates" and "itemTemplates").
// 3. Paste it below as a new entry in the array.
// 4. Give it a nice name (e.g., "Death Factories by CoolUser").
// 5. Save → refresh the app → everyone gets it!

export const HOMEBREW_SETS = [
  // Example placeholder — replace or delete this
  // {
  //   name: "Example Homebrew Pack",
  //   data: {
  //     modelTemplates: [],
  //     itemTemplates: []
  //   }
  // },
  // Paste new homebrew packs below this line
  // {
  //   name: "Death Factories",
  //   data: {
  //     modelTemplates: [ /* pasted models array */ ],
  //     itemTemplates: [ /* pasted items array */ ]
  //   }
  // },
  {
    name: "Byzantine Remnants",
    link: "https://www.myminifactory.com/bundle/2798/Complete-Remnants-of-Old-Byzantium-Bundle-Presupported",
    data: {
      modelTemplates: [
        {
              "id": "byz_princeps_01",
              "templateName": "Menaulatoi Princeps",
              "name": "Menaulatoi Princeps",
              "class": "Byzantine Leader",
              "type": "elite",
              "cost": 75,
              "costCurrency": "ducats",
              "stats": {
                "movement": 6,
                "melee": 1,
                "ranged": 2,
                "baseArmour": 0,
                "finalArmour": 0
              },
              "keywords": [
                "NEW ANTIOCH",
                "ELITE",
                "TOUGH",
                "LEADER"
              ],
              "abilities": [
                {
                  "name": "Menaulatoi",
                  "description": "Gains +1 DICE to ranged attacks when within 4\" of another Menaulatoi. Does not apply to GRENADE weapons."
                },
                {
                  "name": "Vanguard",
                  "description": "Can be deployed on any board edge at least 8\" from enemies if INFILTRATORS allowed. Deploys after INFILTRATORS."
                },
                {
                  "name": "Longspear Doctrine",
                  "description": "Treats Short Range of any ranged weapon as +4\" longer than usual."
                }
              ],
              "skills": [],
              "itemTemplateIds": [],
              "limit": 1
            },
            {
              "id": "byz_warlord_01",
              "templateName": "Varangian Warlord",
              "name": "Varangian Warlord",
              "class": "Byzantine Leader",
              "type": "elite",
              "cost": 90,
              "costCurrency": "ducats",
              "stats": {
                "movement": 6,
                "melee": 3,
                "ranged": 1,
                "baseArmour": -1,
                "finalArmour": -1
              },
              "keywords": [
                "NEW ANTIOCH",
                "ELITE",
                "LEADER",
                "STRONG",
                "TOUGH"
              ],
              "abilities": [
                "Always wears Cataphract armour (locked Piston Reconfiguration). Cannot be changed/replaced.",
                {
                  "name": "Piston Reconfiguration",
                  "description": "+1 Melee, -1 Ranged (already in profile). Gives ASSAULT keyword to ranged weapons with Shield Combo when used with Trench Shield."
                },
                {
                  "name": "Axe Mastery",
                  "description": "On successful charge, immediately make melee attack with one equipped axe. In addition to other attacks."
                },
                {
                  "name": "Shield Bash",
                  "description": "May use any Shield as off-hand weapon with -1 DICE to injury. Functions like Trench Club."
                },
                "Indomitable: Immune to FEAR."
              ],
              "skills": [],
              "itemTemplateIds": [],
              "limit": 1
            },
            {
              "id": "byz_varangian_01",
              "templateName": "Varangian Guard",
              "name": "Varangian Guard",
              "class": "Varangian Guard",
              "type": "trooper",
              "cost": 50,
              "costCurrency": "ducats",
              "stats": {
                "movement": 6,
                "melee": 1,
                "ranged": -1,
                "baseArmour": 0,
                "finalArmour": 0
              },
              "keywords": [
                "NEW ANTIOCH"
              ],
              "abilities": [
                {
                  "name": "Shock Charge",
                  "description": "When charging, roll 2D6, add highest result to charge move."
                },
                "Indomitable: Immune to FEAR.",
                {
                  "name": "Weapon Familiarity",
                  "description": "Ignore HEAVY on all axes. Treat two-handed axes as having Shield Combo. Lose Shock Charge if equipping shield with two-handed axe."
                },
                {
                  "name": "Axe Mastery",
                  "description": "On successful charge, immediately make melee attack with one equipped axe. In addition to other attacks."
                },
                {
                  "name": "Shield Bash",
                  "description": "May use any Shield as off-hand weapon with -1 DICE to injury. Functions like Trench Club."
                }
              ],
              "skills": [],
              "itemTemplateIds": [],
              "upgrades": [
                {
                  "id": "varangian_vanguard",
                  "name": "Vanguard",
                  "cost": 5,
                  "effect": {
                    "type": "add_abilities",
                    "keywords": [],
                    "statChanges": {},
                    "abilities": [
                      {
                        "name": "Vanguard",
                        "description": "Can be deployed on any board edge at least 8\" from enemies if INFILTRATORS allowed. Deploys after INFILTRATORS."
                      }
                    ]
                  }
                }
              ],
              "limit": 4
            },
            {
              "id": "byz_cataphract_01",
              "templateName": "Cataphract Mechanised Infantry",
              "name": "Cataphract Mechanised Infantry",
              "class": "Cataphract Mechanised Infantry",
              "type": "trooper",
              "cost": 65,
              "costCurrency": "ducats",
              "stats": {
                "movement": 6,
                "melee": 0,
                "ranged": 1,
                "baseArmour": -1,
                "finalArmour": -1
              },
              "keywords": [
                "NEW ANTIOCH",
                "STRONG"
              ],
              "abilities": [
                "Always wears Cataphract Armour (counts as Standard Armour, included in profile/cost). Cannot be replaced."
              ],
              "skills": [],
              "itemTemplateIds": [],
              "upgrades": [
                {
                  "id": "cataphract_fire_support",
                  "name": "Fire Support Adaptation",
                  "cost": 5,
                  "effect": {
                    "type": "add_abilities",
                    "keywords": [],
                    "statChanges": {},
                    "abilities": [
                      {
                        "name": "Fire Support Adaptation",
                        "description": "Firing a Machine Gun does not end turn. Lowers Machine Gun range to 24\" and prohibits equipping melee weapons."
                      }
                    ]
                  }
                },
                {
                  "id": "cataphract_piston",
                  "name": "Piston Reconfiguration",
                  "cost": 0,
                  "effect": {
                    "type": "modify_stats",
                    "keywords": [],
                    "statChanges": {
                      "melee": 1,
                      "ranged": -1
                    },
                    "abilities": [
                      {
                        "name": "Piston Reconfiguration",
                        "description": "Gives ASSAULT keyword to ranged weapons with Shield Combo when used with Trench Shield."
                      }
                    ]
                  }
                }
              ],
              "limit": 4
            },
            {
              "id": "byz_yeoman_01",
              "templateName": "Yeoman (Byzantine)",
              "name": "Yeoman",
              "class": "Yeoman",
              "type": "trooper",
              "cost": 30,
              "costCurrency": "ducats",
              "stats": {
                "movement": 6,
                "melee": 0,
                "ranged": 0,
                "baseArmour": 0,
                "finalArmour": 0
              },
              "keywords": [
                "NEW ANTIOCH"
              ],
              "abilities": [
                "May be recruited with Bolt-Action Rifle for reduced cost of 5 👑.",
                {
                  "name": "Longspear Doctrine",
                  "description": "Treats Short Range of any ranged weapon as +4\" longer than usual."
                }
              ],
              "skills": [],
              "itemTemplateIds": [],
              "upgrades": [
                {
                  "id": "yeoman_menaulatoi",
                  "name": "Menaulatoi",
                  "cost": 5,
                  "effect": {
                    "type": "add_abilities",
                    "keywords": [],
                    "statChanges": {},
                    "abilities": [
                      {
                        "name": "Menaulatoi",
                        "description": "Gains +1 DICE to ranged attacks when within 4\" of another Menaulatoi. Does not apply to GRENADE weapons."
                      }
                    ]
                  }
                },
                {
                  "id": "yeoman_vanguard",
                  "name": "Vanguard",
                  "cost": 5,
                  "effect": {
                    "type": "add_abilities",
                    "keywords": [],
                    "statChanges": {},
                    "abilities": [
                      {
                        "name": "Vanguard",
                        "description": "Can be deployed on any board edge at least 8\" from enemies if INFILTRATORS allowed. Deploys after INFILTRATORS."
                      }
                    ]
                  }
                }
              ]
            },
            {
              "id": "byz_sniper_priest_01",
              "templateName": "Sniper Priest (Byzantine)",
              "name": "Sniper Priest",
              "class": "Sniper Priest",
              "type": "elite",
              "cost": 50,
              "costCurrency": "ducats",
              "stats": {
                "movement": 6,
                "melee": -1,
                "ranged": 2,
                "baseArmour": 0,
                "finalArmour": 0
              },
              "keywords": [
                "NEW ANTIOCH",
                "ELITE"
              ],
              "abilities": [
                "Absolute Faith: Opponent cannot spend BLOOD MARKERS to add -DICE to Sniper Priest's Ranged Attacks.",
                {
                  "name": "Aim ACTION",
                  "description": "Risky Success +2 DICE. Success: +2 DICE to Ranged Attack rolls for rest of activation."
                },
                {
                  "name": "Orthodox Patriarchy",
                  "description": "Only 1 Sniper Priest allowed initially. Limit rises to 2 in games with threshold 1200+ ducats."
                }
              ],
              "skills": [],
              "itemTemplateIds": [],
              "limit": 1
            }
          ],
          itemTemplates: [
            {
              "id": "byz_automatic_rifle",
              "templateName": "Automatic Rifle",
              "name": "Automatic Rifle",
              "category": "ranged",
              "keywords": [
                "ASSAULT",
                "AUTOMATIC 2"
              ],
              "range": "24\"",
              "armourModifier": "",
              "notes": "Bayonet Lug, Limit: 2\nFocused Fire: When making 2 Ranged Attacks, same enemy must be target of both.",
              "cost": 40,
              "costCurrency": "ducats"
            },
            {
              "id": "byz_bolt_action_rifle",
              "templateName": "Bolt-Action Rifle",
              "name": "Bolt-Action Rifle",
              "category": "ranged",
              "keywords": [],
              "range": "24\"",
              "armourModifier": "",
              "notes": "Bayonet Lug",
              "cost": 10,
              "costCurrency": "ducats"
            },
            {
              "id": "byz_flamethrower",
              "templateName": "Flamethrower",
              "name": "Flamethrower",
              "category": "ranged",
              "keywords": [
                "-1 INJURY DICE",
                "FIRE",
                "FLAMETHROWER",
                "IGNORE ARMOUR"
              ],
              "range": "8\"",
              "armourModifier": "",
              "notes": "Limit: 2",
              "cost": 30,
              "costCurrency": "ducats"
            },
            {
              "id": "byz_heavy_flamethrower",
              "templateName": "Heavy Flamethrower",
              "name": "Heavy Flamethrower",
              "category": "ranged",
              "keywords": [
                "-1 INJURY DICE",
                "AUTOMATIC 2",
                "FIRE",
                "FLAMETHROWER",
                "HEAVY",
                "IGNORE ARMOUR"
              ],
              "range": "10\"",
              "armourModifier": "",
              "notes": "Limit: 1",
              "cost": 55,
              "costCurrency": "ducats"
            },
            {
              "id": "byz_heavy_shotgun",
              "templateName": "Heavy Shotgun",
              "name": "Heavy Shotgun",
              "category": "ranged",
              "keywords": [
                "+1 DICE",
                "+1 INJURY DICE",
                "HEAVY",
                "SHOTGUN"
              ],
              "range": "12\"",
              "armourModifier": "",
              "notes": "Shield Combo, Limit: 2\nTungsten-orichalcum Alloy Shot: Add +1 INJURY DICE to Ranged Attacks at Short Range.",
              "cost": 20,
              "costCurrency": "ducats"
            },
            {
              "id": "byz_machine_gun",
              "templateName": "Machine Gun",
              "name": "Machine Gun",
              "category": "ranged",
              "keywords": [
                "AUTOMATIC 3",
                "HEAVY",
                "RELOAD"
              ],
              "range": "36\"",
              "armourModifier": "",
              "notes": "Limit: 2",
              "cost": 50,
              "costCurrency": "ducats"
            },
            {
              "id": "byz_pistol",
              "templateName": "Pistol",
              "name": "Pistol",
              "category": "ranged",
              "keywords": [
                "PISTOL"
              ],
              "range": "12\"/Melee",
              "armourModifier": "",
              "notes": "",
              "cost": 6,
              "costCurrency": "ducats"
            },
            {
              "id": "byz_semi_auto_rifle",
              "templateName": "Semi-Automatic Rifle",
              "name": "Semi-Automatic Rifle",
              "category": "ranged",
              "keywords": [
                "ASSAULT"
              ],
              "range": "24\"",
              "armourModifier": "",
              "notes": "Bayonet Lug",
              "cost": 15,
              "costCurrency": "ducats"
            },
            {
              "id": "byz_shotgun",
              "templateName": "Shotgun",
              "name": "Shotgun",
              "category": "ranged",
              "keywords": [
                "+1 DICE",
                "SHOTGUN"
              ],
              "range": "12\"",
              "armourModifier": "",
              "notes": "Bayonet Lug, Shield Combo",
              "cost": 10,
              "costCurrency": "ducats"
            },
            {
              "id": "byz_sniper_rifle",
              "templateName": "Sniper Rifle",
              "name": "Sniper Rifle",
              "category": "ranged",
              "keywords": [
                "+1 DICE",
                "CRITICAL",
                "RISKY"
              ],
              "range": "48\"",
              "armourModifier": "",
              "notes": "Bull's Eye: Critical Success Injury Roll gains IGNORE ARMOUR.",
              "cost": 35,
              "costCurrency": "ducats"
            },
            {
              "id": "byz_submachine_gun",
              "templateName": "Submachine Gun",
              "name": "Submachine Gun",
              "category": "ranged",
              "keywords": [
                "ASSAULT"
              ],
              "range": "16\"",
              "armourModifier": "",
              "notes": "Bayonet Lug, Shield Combo\nQuick Bursts: Can take two Shoot ACTIONS in activation.",
              "cost": 30,
              "costCurrency": "ducats"
            },
            {
              "id": "byz_anti_tank_hammer",
              "templateName": "Anti-Tank Hammer",
              "name": "Anti-Tank Hammer",
              "category": "melee",
              "keywords": [
                "+1 INJURY DICE",
                "CRITICAL",
                "IGNORE ARMOUR",
                "RISKY"
              ],
              "range": "",
              "armourModifier": "",
              "notes": "ELITE only, Limit: 3\nDangerous: Place 1 BLOOD MARKER on Success/Critical.",
              "cost": 35,
              "costCurrency": "ducats"
            },
            {
              "id": "byz_bayonet",
              "templateName": "Bayonet",
              "name": "Bayonet",
              "category": "melee",
              "keywords": [
                "CUMBERSOME"
              ],
              "range": "",
              "armourModifier": "",
              "notes": "Shield Combo",
              "cost": 2,
              "costCurrency": "ducats"
            },
            {
              "id": "byz_great_hammer",
              "templateName": "Great Hammer/Maul",
              "name": "Great Hammer/Maul",
              "category": "melee",
              "keywords": [
                "+1 INJURY MODIFIER",
                "HEAVY"
              ],
              "range": "",
              "armourModifier": "",
              "notes": "",
              "cost": 10,
              "costCurrency": "ducats"
            },
            {
              "id": "byz_great_sword",
              "templateName": "Great Sword/Axe",
              "name": "Great Sword/Axe",
              "category": "melee",
              "keywords": [
                "+1 INJURY DICE",
                "CRITICAL",
                "HEAVY"
              ],
              "range": "",
              "armourModifier": "",
              "notes": "",
              "cost": 12,
              "costCurrency": "ducats"
            },
            {
              "id": "byz_misericordia",
              "templateName": "Misericordia",
              "name": "Misericordia",
              "category": "melee",
              "keywords": [],
              "range": "",
              "armourModifier": "",
              "notes": "Limit: 1\nDespatch: IGNORE ARMOUR vs Down target.",
              "cost": 15,
              "costCurrency": "ducats"
            },
            {
              "id": "byz_polearm",
              "templateName": "Polearm",
              "name": "Polearm",
              "category": "melee",
              "keywords": [
                "BLOCK",
                "CUMBERSOME"
              ],
              "range": "",
              "armourModifier": "",
              "notes": "Shield Combo",
              "cost": 7,
              "costCurrency": "ducats"
            },
            {
              "id": "byz_sword",
              "templateName": "Sword/Axe",
              "name": "Sword/Axe",
              "category": "melee",
              "keywords": [
                "CRITICAL"
              ],
              "range": "",
              "armourModifier": "",
              "notes": "",
              "cost": 4,
              "costCurrency": "ducats"
            },
            {
              "id": "byz_trench_club",
              "templateName": "Trench Club",
              "name": "Trench Club",
              "category": "melee",
              "keywords": [],
              "range": "",
              "armourModifier": "",
              "notes": "",
              "cost": 3,
              "costCurrency": "ducats"
            },
            {
              "id": "byz_trench_knife",
              "templateName": "Trench Knife",
              "name": "Trench Knife",
              "category": "melee",
              "keywords": [
                "-1 DICE"
              ],
              "range": "",
              "armourModifier": "",
              "notes": "",
              "cost": 1,
              "costCurrency": "ducats"
            },
            {
              "id": "byz_frag_grenades",
              "templateName": "Frag Grenades",
              "name": "Frag Grenades",
              "category": "grenade",
              "keywords": [
                "ASSAULT",
                "BLAST 2\"",
                "IGNORE COVER",
                "IGNORE LONG RANGE",
                "SHRAPNEL"
              ],
              "range": "8\"",
              "armourModifier": "",
              "notes": "Limit: 2 (Byzantine restriction)",
              "cost": 7,
              "costCurrency": "ducats"
            },
            {
              "id": "byz_warcross",
              "templateName": "Warcross",
              "name": "Warcross",
              "category": "grenade",
              "keywords": [
                "ASSAULT",
                "IGNORE LONG RANGE"
              ],
              "range": "8\"",
              "armourModifier": "",
              "notes": "",
              "cost": 5,
              "costCurrency": "ducats"
            },
            {
              "id": "byz_holy_icon_shield",
              "templateName": "Holy Icon Shield",
              "name": "Holy Icon Shield",
              "category": "shield",
              "keywords": [
                "IMPERVIOUS"
              ],
              "range": "",
              "armourModifier": "-1 INJURY MODIFIER",
              "notes": "ELITE only, Shield Combo",
              "cost": 2,
              "costCurrency": "glory"
            },
            {
              "id": "byz_trench_shield",
              "templateName": "Trench Shield",
              "name": "Trench Shield",
              "category": "shield",
              "keywords": [],
              "range": "",
              "armourModifier": "-1 INJURY MODIFIER",
              "notes": "Shield Combo",
              "cost": 10,
              "costCurrency": "ducats"
            },
            {
              "id": "byz_standard_armour",
              "templateName": "Standard Armour",
              "name": "Standard Armour",
              "category": "armour",
              "keywords": [],
              "range": "",
              "armourModifier": "-1 INJURY MODIFIER",
              "notes": "",
              "cost": 15,
              "costCurrency": "ducats"
            },
            {
              "id": "byz_binoculars",
              "templateName": "Binoculars",
              "name": "Binoculars",
              "category": "equipment",
              "keywords": [],
              "range": "",
              "armourModifier": "",
              "notes": "ELITE only\nBinoculars: INFILTRATOR cannot deploy within 16\" unless in own zone.",
              "cost": 10,
              "costCurrency": "ducats"
            },
            {
              "id": "byz_blessed_icon",
              "templateName": "Blessed Icon",
              "name": "Blessed Icon",
              "category": "equipment",
              "keywords": [
                "CONSUMABLE"
              ],
              "range": "",
              "armourModifier": "",
              "notes": "Talisman: Once per game, turn a failed Risky Success into success.",
              "cost": 15,
              "costCurrency": "ducats"
            },
            {
              "id": "byz_combat_helmet",
              "templateName": "Combat Helmet",
              "name": "Combat Helmet",
              "category": "equipment",
              "keywords": [
                "NEGATE SHRAPNEL"
              ],
              "range": "",
              "armourModifier": "",
              "notes": "Headgear",
              "cost": 5,
              "costCurrency": "ducats"
            },
            {
              "id": "byz_field_shrine",
              "templateName": "Field Shrine",
              "name": "Field Shrine",
              "category": "equipment",
              "keywords": [],
              "range": "",
              "armourModifier": "",
              "notes": "Deploy terrain piece. +3 models for Morale (max +9). Can be attacked.",
              "cost": 2,
              "costCurrency": "glory"
            },
            {
              "id": "byz_gas_mask",
              "templateName": "Gas Mask",
              "name": "Gas Mask",
              "category": "equipment",
              "keywords": [
                "NEGATE GAS"
              ],
              "range": "",
              "armourModifier": "",
              "notes": "",
              "cost": 5,
              "costCurrency": "ducats"
            },
            {
              "id": "byz_incendiary_ammo",
              "templateName": "Incendiary Ammunition",
              "name": "Incendiary Ammunition",
              "category": "equipment",
              "keywords": [
                "CONSUMABLE"
              ],
              "range": "",
              "armourModifier": "",
              "notes": "Limit: 1\nAdds FIRE to one ranged weapon (no BLAST/FIRE/GAS/SHRAPNEL).",
              "cost": 15,
              "costCurrency": "ducats"
            },
            {
              "id": "byz_iron_capirote",
              "templateName": "Iron Capirote",
              "name": "Iron Capirote",
              "category": "equipment",
              "keywords": [
                "NEGATE FEAR",
                "NEGATE SHRAPNEL"
              ],
              "range": "",
              "armourModifier": "",
              "notes": "Headgear",
              "cost": 7,
              "costCurrency": "ducats"
            },
            {
              "id": "byz_martyrdom_pills",
              "templateName": "Martyrdom Pills",
              "name": "Martyrdom Pills",
              "category": "equipment",
              "keywords": [
                "CONSUMABLE"
              ],
              "range": "",
              "armourModifier": "",
              "notes": "ELITE only, Limit: 3\nConsume on deploy: NEGATE FEAR + -1 INJURY DICE all game.",
              "cost": 20,
              "costCurrency": "ducats"
            },
            {
              "id": "byz_martyrdom_pills_glory",
              "templateName": "Martyrdom Pills (Glory)",
              "name": "Martyrdom Pills",
              "category": "equipment",
              "keywords": [
                "CONSUMABLE"
              ],
              "range": "",
              "armourModifier": "",
              "notes": "ELITE only, Limit: 3\nConsume on deploy: NEGATE FEAR + -1 INJURY DICE all game.",
              "cost": 1,
              "costCurrency": "glory"
            },
            {
              "id": "byz_medikit",
              "templateName": "Medi-kit",
              "name": "Medi-kit",
              "category": "equipment",
              "keywords": [],
              "range": "",
              "armourModifier": "",
              "notes": "Treat ACTION: Risky Success to remove BLOOD MARKER or stand up Down model within 1\".",
              "cost": 5,
              "costCurrency": "ducats"
            },
            {
              "id": "byz_mountaineer_kit",
              "templateName": "Mountaineer Kit",
              "name": "Mountaineer Kit",
              "category": "equipment",
              "keywords": [],
              "range": "",
              "armourModifier": "",
              "notes": "Limit: 4\n+1 DICE to climb sheer surfaces.",
              "cost": 3,
              "costCurrency": "ducats"
            },
            {
              "id": "byz_musical_instrument",
              "templateName": "Musical Instrument",
              "name": "Musical Instrument",
              "category": "equipment",
              "keywords": [
                "HELD"
              ],
              "range": "",
              "armourModifier": "",
              "notes": "Limit: 1\n+1 DICE to Dash for friendly within 4\".",
              "cost": 15,
              "costCurrency": "ducats"
            },
            {
              "id": "byz_troop_flag",
              "templateName": "Troop Flag",
              "name": "Troop Flag",
              "category": "equipment",
              "keywords": [
                "LEADER",
                "HELD"
              ],
              "range": "",
              "armourModifier": "",
              "notes": "Limit: 1",
              "cost": 1,
              "costCurrency": "glory"
            },
            {
              "id": "byz_war_horn_01",
              "templateName": "War Horn",
              "name": "War Horn",
              "category": "equipment",
              "keywords": [
                "HELD",
                "FEAR"
              ],
              "range": "",
              "armourModifier": "",
              "notes": "Varangians only, Limit: 1\nIdentical to Musical Instrument (+1 DICE to Dash for friendly within 4\"), but model carrying it causes FEAR. Shares limit with regular Musical Instrument.",
              "cost": 15,
              "costCurrency": "ducats"
            },
            {
              "id": "byz_phosphorous_01",
              "templateName": "Phosphorous Shells",
              "name": "Phosphorous Shells",
              "category": "equipment",
              "keywords": [
                "FIRE",
                "CONSUMABLE"
              ],
              "range": "",
              "armourModifier": "",
              "notes": "Limit: 2\nBefore battle, grants any equipped shotgun the FIRE keyword until end of battle.",
              "cost": 10,
              "costCurrency": "ducats"
            },
            {
              "id": "byz_dane_axe_01",
              "templateName": "Dane Axe",
              "name": "Dane Axe",
              "category": "melee",
              "keywords": [
                "+1 DICE",
                "HEAVY",
                "CRITICAL"
              ],
              "range": "",
              "armourModifier": "",
              "notes": "Limit: 3\nRolls all injuries with +1 DICE. Treats all combined shield & armour as no more than -1.",
              "cost": 15,
              "costCurrency": "ducats"
            },
            {
              "id": "byz_greek_fire_01",
              "templateName": "Greek Fire",
              "name": "Greek Fire",
              "category": "grenade",
              "keywords": [
                "+1 DICE",
                "HEAVY",
                "BLAST 3\"",
                "FIRE",
                "CONSUMABLE",
                "SCATTER"
              ],
              "range": "6\"",
              "armourModifier": "",
              "notes": "Limit: 3\nRolls 3d6 added together on direct hit, or +1 DICE for others caught in blast. Also causes +1 BLOOD MARKER to all hit due to FIRE.",
        "cost": 15,
        "costCurrency": "ducats"
        },
        {
        "id": "byz_molotov_01",
        "templateName": "Molotov Cocktail",
        "name": "Molotov Cocktail",
        "category": "grenade",
        "keywords": [
        "-1 INJURY DICE",
        "ASSAULT",
        "FIRE",
        "IGNORE COVER",
        "IGNORE LONG RANGE"
        ],
        "range": "6\"",
        "armourModifier": "",
        "notes": "Replaces Incendiary Grenades for Byzantine\nLiquid Fire: Critical Success Injury Roll gains IGNORE ARMOUR.",
        "cost": 5,
        "costCurrency": "ducats"
        }
      ]
    }
  },

  {
    name: "Cadaver Corps",
    link: "https://www.myminifactory.com/users/WestfaliaMiniatures?show=tribe",
    data: {
      modelTemplates: [
        {
          "id": "7kurd9hay",
          "templateName": "Technomancer",
          "name": "NAME",
          "class": "HERETIC LEADER",
          "type": "elite",
          "cost": 80,
          "costCurrency": "ducats",
          "stats": {
            "movement": 6,
            "melee": 2,
            "ranged": 2,
            "baseArmour": 0,
            "finalArmour": 0
          },
          "keywords": ["HERETIC", "CADAVER CORPS", "ARTIFICIAL", "TOUGH", "LEADER"],
          "abilities": [
            {
              "name": "Machine Learning ACTION",
              "description": "choose a ARTIFICIAL friendly model within 12\" if the roll is successful the Technomancers Turn ends and the chosen models activation begins"
            },
            {
              "name": "Obey, don't question RISKY ACTION",
              "description": "command a ARTIFICIAL model within 12\" to do one of the following\n-Conflagrate:\nThe ARTFICIAL model immediately suffers the result of a Minor Wound injury from an attack with the keyword FIRE\n-Overwhelm:\nThe chosen model and on that is within 1\" of it both go down. this does not work against models immune to being downed.\n- Salvage: \nThe chosen model suffers an Out of Action result to remove 2 BLOOD MARKERS on one ARTIFICIAL Model within 12 \" of the Technomancer"
            }
          ],
          "skills": [],
          "itemTemplateIds": [],
          "upgrades": [],
          "limit": 1
        },
        {
          "id": "jfbnn38i2",
          "templateName": "Phosphor Witch",
          "name": "Name",
          "class": "Phosphor Witch",
          "type": "trooper",
          "cost": 95,
          "costCurrency": "ducats",
          "stats": {
            "movement": 6,
            "melee": -1,
            "ranged": 0,
            "baseArmour": 0,
            "finalArmour": 0
          },
          "keywords": ["HERETIC", "CADAVER CORPS", "ARTIFICIAL", "NEGATE FEAR", "NEGATE GAS"],
          "abilities": [
            {
              "name": "Artificial Life",
              "description": "Gas suffers a -1 DICE penalty to injure"
            },
            {
              "name": "Levitate",
              "description": "Climb without taking an ACTION and don't suffer roll on the Injury Chart due to falling"
            }
          ],
          "skills": [],
          "itemTemplateIds": [],
          "upgrades": [],
          "limit": 3
        },
        {
          "id": "yox1865y1",
          "templateName": "War Hyena",
          "name": "Name",
          "class": "War Hyena",
          "type": "trooper",
          "cost": 140,
          "costCurrency": "ducats",
          "stats": {
            "movement": 8,
            "melee": 2,
            "ranged": 0,
            "baseArmour": -2,
            "finalArmour": -2
          },
          "keywords": [],
          "abilities": [
            {
              "name": "Chainmaw",
              "description": "+1 DICE to hit,+1 DICE to Injure, IGNORE ARMOUR, RISKY"
            },
            {
              "name": "Shredding Claws",
              "description": "+1 DICE to Injure, RISKY"
            },
            {
              "name": "Loping Dash",
              "description": "roll DASH ACTIONS with +1 DICE"
            },
            {
              "name": "Appetisers",
              "description": "Ignore the effects of barbed wire"
            },
            {
              "name": "Byzantinium Hear",
              "description": ""
            },
            {
              "name": "Thermal Shielding",
              "description": ""
            }
          ],
          "skills": [],
          "itemTemplateIds": [],
          "upgrades": [],
          "limit": 2
        },
        {
          "id": "hfui6m0qz",
          "templateName": "Heretic Priest (Premade)",
          "name": "Heretic Priest",
          "class": "HERETIC LEADER",
          "type": "elite",
          "cost": 80,
          "costCurrency": "ducats",
          "stats": {
            "movement": 6,
            "melee": 2,
            "ranged": 2,
            "baseArmour": 0,
            "finalArmour": 0
          },
          "keywords": ["HERETIC", "ELITE", "LEADER", "TOUGH"],
          "abilities": [
            "Puppet Master ACTION: Risky Success. Success: Move any model within 12\" LoS D6\" (can charge/Climb/etc).",
            {
              "name": "Blitz",
              "description": "during standard deployment, this model can be placed up to 6\" away from ti's player's deployment Zone"
            }
          ],
          "skills": [],
          "itemTemplateIds": [],
          "upgrades": [],
          "limit": 1
        },
        {
          "id": "aum8gaiw9",
          "templateName": "Death Commando (Premade)",
          "name": "Death Commando",
          "class": "Death Commando",
          "type": "elite",
          "cost": 90,
          "costCurrency": "ducats",
          "stats": {
            "movement": 6,
            "melee": 2,
            "ranged": 1,
            "baseArmour": 0,
            "finalArmour": 0
          },
          "keywords": ["HERETIC", "ELITE", "INFILTRATOR"],
          "abilities": [
            "Stealth Generator: -1 DICE to Ranged Attacks targeting.",
            "Hide ACTION: Risky Success +1 DICE → hidden until move/attack/enemy close."
          ],
          "skills": [],
          "itemTemplateIds": [],
          "upgrades": []
        },
        {
          "id": "xyyraupg8",
          "templateName": "Heretic Trooper (Premade)",
          "name": "Name",
          "class": "Heretic Trooper",
          "type": "trooper",
          "cost": 30,
          "costCurrency": "ducats",
          "stats": {
            "movement": 6,
            "melee": 0,
            "ranged": 0,
            "baseArmour": 0,
            "finalArmour": 0
          },
          "keywords": ["HERETIC"],
          "abilities": [
            {
              "name": "Blitz",
              "description": "during standard deployment, this model can be placed up to 6\" away from ti's player's deployment Zone"
            }
          ],
          "skills": [],
          "itemTemplateIds": [],
          "upgrades": [
            {
              "id": "dvm029ypi",
              "name": "Legionaire (ranged)",
              "cost": 10,
              "effect": {
                "type": "modify_stats",
                "statChanges": {
                  "ranged": 1
                }
              }
            },
            {
              "id": "ma6bowkmn",
              "name": "Legionaire (Melee)",
              "cost": 10,
              "effect": {
                "type": "modify_stats",
                "statChanges": {
                  "melee": 1
                }
              }
            }
          ]
        },
        {
          "id": "h7hwd55hp",
          "templateName": "Wretched (Premade)",
          "name": "Wretched",
          "class": "Wretched",
          "type": "trooper",
          "cost": 25,
          "costCurrency": "ducats",
          "stats": {
            "movement": 6,
            "melee": -1,
            "ranged": -1,
            "baseArmour": 0,
            "finalArmour": 0
          },
          "keywords": ["HERETIC"],
          "abilities": [
            "Chattel: Sell post-game for 25 👑 + half kit cost.",
            "Dark Blessing: On OoA, 1 BLESSING MARKER to nearest friendly ELITE HERETIC.",
            "Law of Hell: OoA enemy ELITE → freed (remove from roster).",
            {
              "name": "Blitz",
              "description": "during standard deployment, this model can be placed up to 6\" away from ti's player's deployment Zone"
            }
          ],
          "skills": [],
          "itemTemplateIds": [],
          "upgrades": []
        },
        {
          "id": "afflcumwt",
          "templateName": "Anointed Heavy Infantry (Premade)",
          "name": "Name",
          "class": "Anointed Heavy Infantry",
          "type": "trooper",
          "cost": 95,
          "costCurrency": "ducats",
          "stats": {
            "movement": 6,
            "melee": 1,
            "ranged": 1,
            "baseArmour": -2,
            "finalArmour": -2
          },
          "keywords": ["HERETIC", "STRONG"],
          "abilities": [
            "Free Reinforced Armour + Infernal Brand (included in profile).",
            {
              "name": "Blitz",
              "description": "during standard deployment, this model can be placed up to 6\" away from ti's player's deployment Zone"
            }
          ],
          "skills": [],
          "itemTemplateIds": [],
          "upgrades": [],
          "limit": 2
        }
      ],
      itemTemplates: [
        {
          "id": "vnicgh6wg",
          "templateName": "Artificial Rebirth",
          "name": "Artificial Rebirth",
          "category": "equipment",
          "keywords": [
            "NEGATE FEAR",
            "ARTIFICIAL",
            "NEGATE GAS"
          ],
          "range": "",
          "armourModifier": "",
          "notes": "Gas attacks suffer a -1 DICE penalty",
          "cost": 1,
          "costCurrency": "glory"
        },
        {
          "id": "4g1jcl3cu",
          "templateName": "Tempered Filigree",
          "name": "Tempered Filigree",
          "category": "armour",
          "keywords": [],
          "range": "",
          "armourModifier": "2",
          "notes": "",
          "cost": 40,
          "costCurrency": "ducats"
        },
        {
          "id": "evjoot4np",
          "templateName": "Thermal Shielding",
          "name": "Thermal Shielding",
          "category": "equipment",
          "keywords": [
            "NEGATE FIRE"
          ],
          "range": "",
          "armourModifier": "",
          "notes": "friendly attacks with the Keyword FIRE roll injuries with -2 DICE against this model",
          "cost": 5,
          "costCurrency": "ducats"
        },
        {
          "id": "krkotzkz4",
          "templateName": "Sonomatic Sculpture",
          "name": "Sonomatic Sculpture",
          "category": "equipment",
          "keywords": [],
          "range": "",
          "armourModifier": "",
          "notes": "Once this model has moved a minimum of 6\" this turn, it has the FEAR keyword until the beginning of its next aktivation",
          "cost": 5,
          "costCurrency": "ducats"
        },
        {
          "id": "8imldw9kn",
          "templateName": "Enhanced Agility",
          "name": "Enhanced Agility",
          "category": "equipment",
          "keywords": [],
          "range": "",
          "armourModifier": "",
          "notes": "This model Ignores the effects of difficult and dangerous terrain",
          "cost": 5,
          "costCurrency": "ducats"
        },
        {
          "id": "m856t7r04",
          "templateName": "Unstoppable",
          "name": "Unstoppable",
          "category": "equipment",
          "keywords": [],
          "range": "",
          "armourModifier": "",
          "notes": "Your Opponent cannot spend BLOOD MARKERS on this models's Dash ACTIONS.",
          "cost": 5,
          "costCurrency": "ducats"
        },
        {
          "id": "ukcjm0wqo",
          "templateName": "Melee Chassis",
          "name": "Melee Chassis",
          "category": "melee",
          "keywords": [],
          "range": "",
          "armourModifier": "",
          "notes": "counts either as two flails or a misericordia",
          "cost": 15,
          "costCurrency": "ducats"
        },
        {
          "id": "obhfk7a1l",
          "templateName": "Essence Extractor",
          "name": "Essence Extractor",
          "category": "equipment",
          "keywords": [],
          "range": "",
          "armourModifier": "",
          "notes": "Once per turn, when inflicting a BLOOD MARKER due to a melee attack action , it can remove up to one BLOOD MARKER from itself",
          "cost": 5,
          "costCurrency": "ducats",
          "limit": 2
        },
        {
          "id": "nh298uu70",
          "templateName": "Byzantium Heart",
          "name": "Byzantium Heart",
          "category": "equipment",
          "keywords": [],
          "range": "",
          "armourModifier": "",
          "notes": "This model treats any DOWN INJURY result as a MINOR INJURY, unless it is due to the TOUGH keyword.",
          "cost": 10,
          "costCurrency": "ducats",
          "limit": 2
        },
        {
          "id": "j54k2h9rk",
          "templateName": "Vessel of Original Sin",
          "name": "Vessel of Original Sin",
          "category": "equipment",
          "keywords": [
            "CONSUMABLE"
          ],
          "range": "",
          "armourModifier": "",
          "notes": "reduce the result of any roll made by a model within 6\" by 1 BEFORE it is rolled.",
          "cost": 1,
          "costCurrency": "ducats",
          "limit": 1
        },
        {
          "id": "igvivlw56",
          "templateName": "Phosphor Bomb",
          "name": "Phosphor Bomb",
          "category": "ranged",
          "keywords": [
            "BLAST 3\"",
            "SCATTER",
            "FIRE",
            "IGNORE COVER",
            "IGNORE LONG RANGE"
          ],
          "range": "18",
          "armourModifier": "",
          "notes": "roll with 3D6 on direct hit\nAny model directly hit is blown D3\" directly away from the point of impact",
          "cost": 0,
          "costCurrency": "free"
        },
        {
          "id": "vhmtg9qnn",
          "templateName": "Bayonet (Premade)",
          "name": "Bayonet",
          "category": "melee",
          "keywords": [
            "CUMBERSOME"
          ],
          "range": "",
          "armourModifier": "",
          "notes": "Shield Combo",
          "cost": 2,
          "costCurrency": "ducats"
        },
        {
          "id": "r2b7g1agc",
          "templateName": "Blasphemous Staff (Premade)",
          "name": "Blasphemous Staff",
          "category": "melee",
          "keywords": [
            "CRITICAL",
            "FIRE"
          ],
          "range": "",
          "armourModifier": "",
          "notes": "ELITE only\nEvil Power: +1 DICE to non-attack/non-Dash Success/Risky Rolls.",
          "cost": 2,
          "costCurrency": "glory"
        },
        {
          "id": "b1kae5rp1",
          "templateName": "Great Hammer/Maul (Premade)",
          "name": "Great Hammer/Maul",
          "category": "melee",
          "keywords": [
            "+1 INJURY MODIFIER",
            "HEAVY"
          ],
          "range": "",
          "armourModifier": "",
          "notes": "",
          "cost": 10,
          "costCurrency": "ducats"
        },
        {
          "id": "889serg2u",
          "templateName": "Great Sword/Axe (Premade)",
          "name": "Great Sword/Axe",
          "category": "melee",
          "keywords": [
            "+1 INJURY DICE",
            "CRITICAL",
            "HEAVY"
          ],
          "range": "",
          "armourModifier": "",
          "notes": "",
          "cost": 12,
          "costCurrency": "ducats"
        },
        {
          "id": "bwmit13rz",
          "templateName": "Hellblade (Premade)",
          "name": "Hellblade",
          "category": "melee",
          "keywords": [
            "+1 INJURY DICE",
            "FIRE"
          ],
          "range": "",
          "armourModifier": "",
          "notes": "Limit: 2",
          "cost": 1,
          "costCurrency": "glory"
        },
        {
          "id": "3mwlt89vx",
          "templateName": "Polearm (Premade)",
          "name": "Polearm",
          "category": "melee",
          "keywords": [
            "BLOCK",
            "CUMBERSOME"
          ],
          "range": "",
          "armourModifier": "",
          "notes": "Shield Combo",
          "cost": 7,
          "costCurrency": "ducats"
        },
        {
          "id": "blq50zd9q",
          "templateName": "Sacrificial Blade (Premade)",
          "name": "Sacrificial Blade",
          "category": "melee",
          "keywords": [
            "+2 INJURY MODIFIER",
            "RISKY"
          ],
          "range": "",
          "armourModifier": "",
          "notes": "ELITE only, Limit: 2",
          "cost": 23,
          "costCurrency": "ducats"
        },
        {
          "id": "1a4yjinm1",
          "templateName": "Sword/Axe (Premade)",
          "name": "Sword/Axe",
          "category": "melee",
          "keywords": [
            "CRITICAL"
          ],
          "range": "",
          "armourModifier": "",
          "notes": "",
          "cost": 4,
          "costCurrency": "ducats"
        },
        {
          "id": "butfpc7te",
          "templateName": "Tartarus Claws (Premade)",
          "name": "Tartarus Claws",
          "category": "melee",
          "keywords": [
            "CRITICAL",
            "CUMBERSOME"
          ],
          "range": "",
          "armourModifier": "",
          "notes": "Death Commando only\nPaired Weapon: No Off-Hand penalty. On Down/OoA: move up to 3\" and Fight again.",
          "cost": 15,
          "costCurrency": "ducats"
        },
        {
          "id": "372yvmopv",
          "templateName": "Trench Club (Premade)",
          "name": "Trench Club",
          "category": "melee",
          "keywords": [],
          "range": "",
          "armourModifier": "",
          "notes": "",
          "cost": 3,
          "costCurrency": "ducats"
        },
        {
          "id": "80yuaeusa",
          "templateName": "Trench Knife (Premade)",
          "name": "Trench Knife",
          "category": "melee",
          "keywords": [
            "-1 DICE"
          ],
          "range": "",
          "armourModifier": "",
          "notes": "",
          "cost": 1,
          "costCurrency": "ducats"
        },
        {
          "id": "bui33e2w7",
          "templateName": "Automatic Rifle (Premade)",
          "name": "Automatic Rifle",
          "category": "ranged",
          "keywords": [
            "ASSAULT",
            "AUTOMATIC 2"
          ],
          "range": "24\"",
          "cost": 2,
          "costCurrency": "glory",
          "notes": "Bayonet Lug, Limit: 2"
        },
        {
          "id": "wgab111u0",
          "templateName": "Automatic Shotgun (Premade)",
          "name": "Automatic Shotgun",
          "category": "ranged",
          "keywords": [
            "+1 DICE",
            "ASSAULT",
            "SHOTGUN"
          ],
          "range": "12\"",
          "cost": 15,
          "costCurrency": "ducats",
          "notes": "Bayonet Lug, Shield Combo"
        },
        {
          "id": "acap2httj",
          "templateName": "Bolt-Action Rifle (Premade)",
          "name": "Bolt-Action Rifle",
          "category": "ranged",
          "keywords": [],
          "range": "24\"",
          "cost": 10,
          "costCurrency": "ducats",
          "notes": "Bayonet Lug"
        },
        {
          "id": "3fo529wzu",
          "templateName": "Flamethrower (Premade)",
          "name": "Flamethrower",
          "category": "ranged",
          "keywords": [
            "-1 INJURY DICE",
            "FIRE",
            "FLAMETHROWER",
            "IGNORE ARMOUR"
          ],
          "range": "8\"",
          "cost": 30,
          "costCurrency": "ducats",
          "notes": "Limit: 3"
        },
        {
          "id": "inoml4phv",
          "templateName": "Pistol (Premade)",
          "name": "Pistol",
          "category": "ranged",
          "keywords": [
            "PISTOL"
          ],
          "range": "12\"/Melee",
          "cost": 6,
          "costCurrency": "ducats",
          "notes": ""
        },
        {
          "id": "fea1cbpl4",
          "templateName": "Semi-Automatic Rifle (Premade)",
          "name": "Semi-Automatic Rifle",
          "category": "ranged",
          "keywords": [
            "ASSAULT"
          ],
          "range": "24\"",
          "cost": 15,
          "costCurrency": "ducats",
          "notes": "Bayonet Lug"
        },
        {
          "id": "7xx23jw25",
          "templateName": "Shotgun (Premade)",
          "name": "Shotgun",
          "category": "ranged",
          "keywords": [
            "+1 DICE",
            "SHOTGUN"
          ],
          "range": "12\"",
          "cost": 10,
          "costCurrency": "ducats",
          "notes": "Bayonet Lug, Shield Combo"
        },
        {
          "id": "b7xh21erf",
          "templateName": "Silenced Pistol (Premade)",
          "name": "Silenced Pistol",
          "category": "ranged",
          "keywords": [
            "ASSAULT",
            "PISTOL"
          ],
          "range": "12\"/Melee",
          "cost": 15,
          "costCurrency": "ducats",
          "notes": "ELITE only\nSilent: +1 DICE if attacker in contact with terrain ≥½\" tall between attacker and target."
        },
        {
          "id": "39w6059yx",
          "templateName": "Submachine Gun (Premade)",
          "name": "Submachine Gun",
          "category": "ranged",
          "keywords": [
            "ASSAULT"
          ],
          "range": "16\"",
          "cost": 2,
          "costCurrency": "glory",
          "notes": "Bayonet Lug, Shield Combo\nQuick Bursts: Can take two Shoot ACTIONS in activation."
        },
        {
          "id": "uy4334cri",
          "templateName": "Reinforced Armour (Premade)",
          "name": "Reinforced Armour",
          "category": "armour",
          "keywords": [],
          "range": "",
          "armourModifier": "-2 INJURY MODIFIER",
          "notes": "Anointed & ELITE only",
          "cost": 40,
          "costCurrency": "ducats"
        },
        {
          "id": "73d27zxni",
          "templateName": "Standard Armour (Premade)",
          "name": "Standard Armour",
          "category": "armour",
          "keywords": [],
          "range": "",
          "armourModifier": "-1 INJURY MODIFIER",
          "notes": "",
          "cost": 15,
          "costCurrency": "ducats"
        },
        {
          "id": "3w2hxobd1",
          "templateName": "Trench Shield (Premade)",
          "name": "Trench Shield",
          "category": "shield",
          "keywords": [],
          "range": "",
          "armourModifier": "-1 INJURY MODIFIER",
          "notes": "Shield Combo",
          "cost": 10,
          "costCurrency": "ducats"
        },
        {
          "id": "w6ac9ezts",
          "templateName": "Frag Grenades (Premade)",
          "name": "Frag Grenades",
          "category": "grenade",
          "keywords": [
            "ASSAULT",
            "BLAST 2\"",
            "IGNORE COVER",
            "IGNORE LONG RANGE",
            "SHRAPNEL"
          ],
          "range": "8\"",
          "armourModifier": "",
          "notes": "",
          "cost": 7,
          "costCurrency": "ducats"
        },
        {
          "id": "zyf236u68",
          "templateName": "Gas Grenades (Premade)",
          "name": "Gas Grenades",
          "category": "grenade",
          "keywords": [
            "-1 INJURY DICE",
            "ASSAULT",
            "BLAST 3\"",
            "GAS",
            "IGNORE ARMOUR",
            "IGNORE COVER",
            "IGNORE LONG RANGE"
          ],
          "range": "8\"",
          "armourModifier": "",
          "notes": "",
          "cost": 10,
          "costCurrency": "ducats"
        },
        {
          "id": "eol8jm2ux",
          "templateName": "Incendiary Grenades (Premade)",
          "name": "Incendiary Grenades",
          "category": "grenade",
          "keywords": [
            "ASSAULT",
            "FIRE",
            "IGNORE COVER",
            "IGNORE LONG RANGE"
          ],
          "range": "8\"",
          "armourModifier": "",
          "notes": "Liquid Fire: Critical Success Injury Roll gains IGNORE ARMOUR.",
          "cost": 15,
          "costCurrency": "ducats"
        },
        {
          "id": "fr0x9wxx1",
          "templateName": "Binoculars (Premade)",
          "name": "Binoculars",
          "category": "equipment",
          "keywords": [],
          "range": "",
          "armourModifier": "",
          "notes": "ELITE only",
          "cost": 10,
          "costCurrency": "ducats"
        },
        {
          "id": "g3yogbnw0",
          "templateName": "Combat Helmet (Premade)",
          "name": "Combat Helmet",
          "category": "equipment",
          "keywords": [
            "NEGATE SHRAPNEL"
          ],
          "range": "",
          "armourModifier": "",
          "notes": "Headgear",
          "cost": 5,
          "costCurrency": "ducats"
        },
        {
          "id": "b2dhkpdhy",
          "templateName": "Gas Mask (Premade)",
          "name": "Gas Mask",
          "category": "equipment",
          "keywords": [
            "NEGATE GAS"
          ],
          "range": "",
          "armourModifier": "",
          "notes": "",
          "cost": 5,
          "costCurrency": "ducats"
        },
        {
          "id": "r21aru9vf",
          "templateName": "Hellbound Soul Contract (Premade)",
          "name": "Hellbound Soul Contract",
          "category": "equipment",
          "keywords": [],
          "range": "",
          "armourModifier": "",
          "notes": "Heretic Troopers & Legionnaires only, Limit: 3\nOn OoA: add 1 BLOOD MARKER to each enemy within 1\" (not NEGATE FIRE).",
          "cost": 5,
          "costCurrency": "ducats"
        },
        {
          "id": "tyol7oghh",
          "templateName": "Incendiary Ammunition (Premade)",
          "name": "Incendiary Ammunition",
          "category": "equipment",
          "keywords": [
            "CONSUMABLE"
          ],
          "range": "",
          "armourModifier": "",
          "notes": "Limit: 1\nAdds FIRE to one ranged weapon (no BLAST/FIRE/GAS/SHRAPNEL).",
          "cost": 15,
          "costCurrency": "ducats"
        },
        {
          "id": "9203lds72",
          "templateName": "Infernal Brand (Premade)",
          "name": "Infernal Brand",
          "category": "equipment",
          "keywords": [
            "NEGATE FIRE"
          ],
          "range": "",
          "armourModifier": "",
          "notes": "",
          "cost": 5,
          "costCurrency": "ducats"
        },
        {
          "id": "lre4x3vvs",
          "templateName": "Mountaineer Kit (Premade)",
          "name": "Mountaineer Kit",
          "category": "equipment",
          "keywords": [],
          "range": "",
          "armourModifier": "",
          "notes": "Limit: 2",
          "cost": 3,
          "costCurrency": "ducats"
        },
        {
          "id": "hizj9fa77",
          "templateName": "Musical Instrument (Premade)",
          "name": "Musical Instrument",
          "category": "equipment",
          "keywords": [
            "HELD"
          ],
          "range": "",
          "armourModifier": "",
          "notes": "Limit: 1",
          "cost": 15,
          "costCurrency": "ducats"
        },
        {
          "id": "igvtk48tx",
          "templateName": "Shovel (Premade)",
          "name": "Shovel",
          "category": "equipment",
          "keywords": [],
          "range": "",
          "armourModifier": "",
          "notes": "",
          "cost": 5,
          "costCurrency": "ducats"
        },
        {
          "id": "jvxlfeb6b",
          "templateName": "Troop Flag (Premade)",
          "name": "Troop Flag",
          "category": "equipment",
          "keywords": [
            "LEADER",
            "HELD"
          ],
          "range": "",
          "armourModifier": "",
          "notes": "Limit: 1",
          "cost": 1,
          "costCurrency": "glory"
        },
        {
          "id": "k8a95usib",
          "templateName": "Unholy Relic (Premade)",
          "name": "Unholy Relic",
          "category": "equipment",
          "keywords": [
            "FEAR"
          ],
          "range": "",
          "armourModifier": "",
          "notes": "",
          "cost": 15,
          "costCurrency": "ducats"
        },
        {
          "id": "eiwsmt0nu",
          "templateName": "Unholy Trinket (Premade)",
          "name": "Unholy Trinket",
          "category": "equipment",
          "keywords": [
            "CONSUMABLE"
          ],
          "range": "",
          "armourModifier": "",
          "notes": "Talisman: Once per game, turn failed Risky Success into success.",
          "cost": 15,
          "costCurrency": "ducats"
        }  
      ]
    }
  },
  {
    name: "Harvesting Legion",
    // link: "https://your-link-here.com", // Optional: add images/discord post/etc.
    data: {
      modelTemplates: [
        {
          "id": "hl001mwpriest",
          "templateName": "Masterworked Heretic Priest",
          "name": "Masterworked Heretic Priest",
          "class": "HERETIC LEADER",
          "type": "elite",
          "cost": 85,
          "costCurrency": "ducats",
          "stats": {
            "movement": 6,
            "melee": 3,
            "ranged": 1,
            "baseArmour": 0,
            "finalArmour": 0
          },
          "keywords": ["HERETIC", "ELITE", "LEADER", "ARTIFICIAL", "NEGATE FEAR", "NEGATE GAS"],
          "abilities": [
            {
              "name": "Allied Munition ACTION",
              "description": "RISKY ACTION: Designate a spot within 30” and LoS where a Wretched Flesh Suit will fit. If >15\" away, -1 DICE. On failure treat as SCATTER (enemy moves spot). Place a neutral Wretched Flesh Suit there (never activates, OoA when new one created). Units within 1” cannot leave melee until it dies."
            }
          ],
          "skills": [],
          "itemTemplateIds": [],
          "upgrades": [],
          "limit": 1
        },
        {
          "id": "hl002execwitch",
          "templateName": "Masterworked Executioner Witch",
          "name": "Masterworked Executioner Witch",
          "class": "Masterworked Witch/Assassin",
          "type": "elite",
          "cost": 100,
          "costCurrency": "ducats",
          "stats": {
            "movement": 8,
            "melee": 2,
            "ranged": 0,
            "baseArmour": 0,
            "finalArmour": 0
          },
          "keywords": ["HERETIC", "ELITE", "ARTIFICIAL", "NEGATE FEAR", "NEGATE GAS"],
          "abilities": [
            {
              "name": "Abiotic Life",
              "description": "-1 INJURY DICE from attacks with GAS keyword"
            },
            {
              "name": "Levitate",
              "description": "No Risky Success Roll for Climb/Jump, no Injury Roll on Fall"
            }
          ],
          "skills": [],
          "itemTemplateIds": ["hl_smogbomb"],
          "upgrades": [],
          "limit": 2 // Combined limit with Masterworked Assassin at ≥1000 ducats threshold (handled in app rules)
        },
        {
          "id": "hl003assassin",
          "templateName": "Masterworked Assassin",
          "name": "Masterworked Assassin",
          "class": "Masterworked Witch/Assassin",
          "type": "elite",
          "cost": 100,
          "costCurrency": "ducats",
          "stats": {
            "movement": 6,
            "melee": 2,
            "ranged": 1,
            "baseArmour": 0,
            "finalArmour": 0
          },
          "keywords": ["HERETIC", "ELITE", "ARTIFICIAL", "NEGATE FEAR", "NEGATE GAS"],
          "abilities": [
            {
              "name": "Torment Surge",
              "description": "On legal CHARGE: move rolled distance in straight line (pass through enemies, full base clear). Make 1 melee attack vs each model on path. At activation end, Injury Roll -2 DICE per use (can chain with successful DASH)."
            },
            {
              "name": "Infernally Laced Meth",
              "description": "+1 DICE to DASH, CLIMB, DOWNHILL CHARGE"
            },
            {
              "name": "Shadow Veil",
              "description": "May HIDE as Death Commando, but only vs attacks/abilities >6\" away. Loses HIDE on Move or enemy ends Move within 1\"."
            }
          ],
          "skills": [],
          "itemTemplateIds": [],
          "upgrades": []
        },
        {
          "id": "hl004goetic",
          "templateName": "Masterworked Goetic Warlock",
          "name": "Masterworked Goetic Warlock",
          "class": "Masterworked Warlock/Communicant",
          "type": "elite",
          "cost": 120,
          "costCurrency": "ducats",
          "stats": {
            "movement": 8,
            "melee": 2,
            "ranged": 0,
            "baseArmour": 0,
            "finalArmour": 0
          },
          "keywords": ["HERETIC", "ELITE", "ARTIFICIAL", "FEAR", "NEGATE GAS"],
          "abilities": [
            "Reinforced Armour included",
            {
              "name": "Barbed Embrace",
              "description": "Enemy within 1\" cannot Retreat"
            },
            {
              "name": "Iron-Clawed Hands",
              "description": "Can melee attack twice with CRITICAL (Off-Hand penalty on second)"
            },
            {
              "name": "Goetic Gaze ACTION",
              "description": "Success: 1 BLOOD MARKER on enemy within 24\"/LoS; Critical: 2 BLOOD MARKERS"
            },
            {
              "name": "Goetic Portal ACTION",
              "description": "Risky Success +1 DICE: Redeploy within 6\". Can bring one enemy (32mm or smaller) within 1\". Can redeploy even Down or in melee."
            }
          ],
          "skills": [],
          "itemTemplateIds": [],
          "upgrades": []
        },
        {
          "id": "hl005communicant",
          "templateName": "Heretic Communicant",
          "name": "Heretic Communicant",
          "class": "Masterworked Warlock/Communicant",
          "type": "elite",
          "cost": 100,
          "costCurrency": "ducats",
          "stats": {
            "movement": 6,
            "melee": 2,
            "ranged": -3,
            "baseArmour": 0,
            "finalArmour": 0
          },
          "keywords": ["HERETIC", "ELITE", "ARTIFICIAL", "STRONG", "NEGATE FEAR", "NEGATE GAS"],
          "abilities": [
            {
              "name": "Unstable",
              "description": "On activation, enemy may spend BLOOD MARKERS (1 per ACTION) to force neutral ACTIONS before normal activation"
            },
            {
              "name": "Miracle of Infernal Flesh",
              "description": "On Injury Chart, set one DICE to 2 before rolling"
            }
          ],
          "skills": [],
          "itemTemplateIds": [],
          "upgrades": []
        },
        {
          "id": "hl006overseer",
          "templateName": "Anointed Factory Overseer",
          "name": "Anointed Factory Overseer",
          "class": "Anointed Factory Overseer",
          "type": "elite",
          "cost": 105,
          "costCurrency": "ducats",
          "stats": {
            "movement": 6,
            "melee": 1,
            "ranged": 1,
            "baseArmour": -2,
            "finalArmour": -2
          },
          "keywords": ["HERETIC", "ARTIFICIAL", "STRONG", "NEGATE GAS"],
          "abilities": [
            "Reinforced Armour + Infernal Brand included (cannot be removed)",
            {
              "name": "Hunter",
              "description": "If no Ranged weapon or Trench Shield: Downed enemy within 1\" cannot stand (unless ≥40mm). +1 DICE to DASH"
            },
            {
              "name": "Bodyguard",
              "description": "If equipped with Shield: May take hit for friendly HERETIC within 1\" (not BLAST)"
            }
          ],
          "skills": [],
          "itemTemplateIds": [],
          "upgrades": [],
          "limit": 4
        },
        {
          "id": "hl007wretched",
          "templateName": "Wretched Flesh Suit",
          "name": "Wretched Flesh Suit",
          "class": "Wretched Flesh Suit",
          "type": "trooper",
          "cost": 22,
          "costCurrency": "ducats",
          "stats": {
            "movement": 10,
            "melee": 0,
            "ranged": -1,
            "baseArmour": 0,
            "finalArmour": 0
          },
          "keywords": ["HERETIC", "ARTIFICIAL", "NEGATE GAS"],
          "abilities": [
            {
              "name": "Fragile Frame",
              "description": "Any DOWN converted to Out of Action"
            },
            {
              "name": "Mechanical Limbs",
              "description": "Cannot DASH"
            },
            {
              "name": "Hellbound Soul Contract",
              "description": "On OoA: 1 BLOOD MARKER to each enemy within 1\" (NEGATE FIRE immune)"
            }
          ],
          "skills": [],
          "itemTemplateIds": [],
          "upgrades": []
        },
        {
          "id": "hl008sapper",
          "templateName": "Heretic Sapper",
          "name": "Heretic Sapper",
          "class": "Heretic Sapper",
          "type": "trooper",
          "cost": 55,
          "costCurrency": "ducats",
          "stats": {
            "movement": 6,
            "melee": 0,
            "ranged": 1,
            "baseArmour": 0,
            "finalArmour": 0
          },
          "keywords": ["HERETIC", "ARTIFICIAL", "NEGATE GAS"],
          "abilities": [
            "Shovel included",
            {
              "name": "Set Gas Mine ACTION",
              "description": "Success +1 DICE: Place Gas Mine (2\" trigger radius, not touching enemy)"
            },
            {
              "name": "Defuse Mine",
              "description": "As core rules"
            },
            {
              "name": "Fortify ACTION",
              "description": "Risky Success: Gain COVER until move away"
            },
            {
              "name": "Forward Positions",
              "description": "Deploy up to 6\" outside deployment zone, in contact with ≥½\" terrain"
            }
          ],
          "skills": [],
          "itemTemplateIds": [],
          "upgrades": [],
          "limit": 2
        },
        {
          "id": "hl009warwolf",
          "templateName": "War Wolf Assault Beast",
          "name": "War Wolf Assault Beast",
          "class": "War Wolf Assault Beast",
          "type": "trooper",
          "cost": 150,
          "costCurrency": "ducats",
          "stats": {
            "movement": 8,
            "melee": 2,
            "ranged": 0,
            "baseArmour": -3,
            "finalArmour": -3
          },
          "keywords": ["HERETIC", "ARTIFICIAL", "NEGATE GAS", "FEAR", "TOUGH"],
          "abilities": [
            {
              "name": "Chainmaw / Flamemaw",
              "description": "Main hand: +1 DICE hit, +1 DICE injure, IGNORE ARMOUR (if Flamemaw: +FIRE)"
            },
            {
              "name": "Shredding Claws",
              "description": "Off hand: +1 DICE injure"
            },
            {
              "name": "Loping Dash",
              "description": "+1 DICE to DASH, ignore Difficult terrain penalty (disabled with Flamemaw)"
            }
          ],
          "skills": [],
          "itemTemplateIds": [],
          "upgrades": [],
          "limit": 1
        },
        {
          "id": "hl010warhound",
          "templateName": "War Assault Hound",
          "name": "War Assault Hound",
          "class": "War Assault Hound",
          "type": "trooper",
          "cost": 50,
          "costCurrency": "ducats",
          "stats": {
            "movement": 8,
            "melee": 1,
            "ranged": 0,
            "baseArmour": 0,
            "finalArmour": 0
          },
          "keywords": ["HERETIC", "ARTIFICIAL", "NEGATE GAS"],
          "abilities": [
            {
              "name": "Infernal Flesh",
              "description": "+1 DICE to Climb/Jump/Fall/DASH. Treat Trench Walls as sheer"
            },
            {
              "name": "Hell Pack Tactics",
              "description": "Friendly units may Risky Success charge enemy out of LoS if enemy within 1\" of this model"
            },
            {
              "name": "Head Variant",
              "description": "Mini Chainsaw Head (+5 ducats): Melee as Chainmaw; OR Harpoon Head (base cost): Melee attack can pull target 3\" toward model"
            }
          ],
          "skills": [],
          "itemTemplateIds": [],
          "upgrades": []
        }
      ],
      itemTemplates: [
        {
          "id": "hl_execsword",
          "templateName": "Executioner Sword",
          "name": "Executioner Sword",
          "category": "melee",
          "keywords": ["+1 INJURY DICE", "CRITICAL", "RISKY", "CUMBERSOME"],
          "range": "",
          "armourModifier": "",
          "notes": "2-Handed. ELITE only, Limit 1.\nBiting Edge: Reroll all Injury dice (or choose if vs retreating/down).\nThirsty Blade: Each rerolled 1 → +1 BLOOD MARKER on wielder.",
          "cost": 23,
          "costCurrency": "ducats",
          "limit": 1,
          "restrictions": ["ELITE only"]
        },
        {
          "id": "hl_tartarusaxe",
          "templateName": "Tartarus Axe",
          "name": "Tartarus Axe",
          "category": "melee",
          "keywords": ["+1 INJURY DICE", "RISKY", "CUMBERSOME"],
          "range": "",
          "armourModifier": "",
          "notes": "2-Handed. Limit 2.\nOverbalanced Head: If CHARGE this turn or target DOWN → second Off-Hand attack vs same target.",
          "cost": 15,
          "costCurrency": "ducats",
          "limit": 2
        },
        {
          "id": "hl_harpoon",
          "templateName": "Man-hunter Harpoon",
          "name": "Man-hunter Harpoon",
          "category": "melee",
          "keywords": ["IGNORE LONG RANGE", "SHIELD COMBO"],
          "range": "Melee/12\"",
          "armourModifier": "",
          "notes": "2-Handed. Limit 3.\nReeling Hook: On BLOOD MARKER → pull 3\" toward you OR fling over base to opposite side 1.1\" away (no Opportunity Attack).",
          "cost": 20,
          "costCurrency": "ducats",
          "limit": 3
        },
        {
          "id": "hl_humaninstrument",
          "templateName": "Human Instrument",
          "name": "Human Instrument",
          "category": "equipment",
          "keywords": [],
          "range": "",
          "armourModifier": "",
          "notes": "Limit 1.\nTortured Fanfare: Post-deployment place neutral immobile Wretched Flesh Suit. +1 DICE to friendly DASH Risky Rolls within 8\".",
          "cost": 35,
          "costCurrency": "ducats",
          "limit": 1
        },
        {
          "id": "hl_icarusarmour",
          "templateName": "Icarus Armour",
          "name": "Icarus Armour",
          "category": "armour",
          "keywords": ["NEGATE [NEGATE FIRE]"],
          "range": "",
          "armourModifier": "-2 INJURY MODIFIER",
          "notes": "Limit 1.\nWaxen Wings: Movement becomes 6\"/Flying, vertical climb free.",
          "cost": 40,
          "costCurrency": "ducats",
          "limit": 1
        },
        {
          "id": "hl_smogbomb",
          "templateName": "Smog Bomb",
          "name": "Smog Bomb",
          "category": "ranged",
          "keywords": ["ASSAULT", "BLAST 4\"", "IGNORE COVER", "IGNORE ELEVATED POSITION", "IGNORE LONG RANGE", "SCATTER [*2]"],
          "range": "30\"",
          "armourModifier": "",
          "notes": "1-Handed. Dense Smog: No Injury/Blood. Place 4\" cloud (-1 DICE to attacks through/into). Remove on next activation or death.\nMighty Airburst: Non-direct hits pushed D3\" away (treat as retreating for Opportunity Attacks by non-moved enemies).",
          "cost": 0,
          "costCurrency": "free"
        },
        {
          "id": "hl_gasmine",
          "templateName": "Gas Mine",
          "name": "Gas Mine",
          "category": "grenade",
          "keywords": ["BLAST 3\"", "GAS"],
          "range": "2\" trigger",
          "armourModifier": "",
          "notes": "Trigger on move within 2\" (not setter or defuser; flying only on landing). Injury Roll with GAS, then remove mine.",
          "cost": 0,
          "costCurrency": "free"
        }
      ]
    }
  },
  {
    name: "Assassin Redux",
    link: "-",
    data: {
      modelTemplates: [
        {
          "id": "mml7oy6t5",
          "templateName": "Azeb",
          "name": "Azeb",
          "class": "Azeb",
          "type": "trooper",
          "cost": 25,
          "costCurrency": "ducats",
          "stats": {
            "movement": 6,
            "melee": -1,
            "ranged": 0,
            "baseArmour": 0,
            "finalArmour": 0
          },
          "keywords": [
            "SULTANATE"
          ],
          "abilities": [
            "Light Skirmishers: +5 👑 each for SKIRMISHER."
          ],
          "skills": [],
          "itemTemplateIds": []
        },
        {
          "id": "75oofll40",
          "templateName": "Pashtun Marksman (0-3)",
          "name": "Pashtun Marksman",
          "class": "Pashtun Marksman",
          "type": "trooper",
          "cost": 50,
          "costCurrency": "ducats",
          "stats": {
            "movement": 6,
            "melee": 0,
            "ranged": 1,
            "baseArmour": 0,
            "finalArmour": 0
          },
          "keywords": [
            "SULTANATE"
          ],
          "abilities": [
            "Defuse Mine: Risky Success to defuse.",
            "Fortify ACTION: Risky Success → COVER until move.",
            "Forward Positions: Deploy up to 6\" forward in contact with terrain.",
            {
              "name": "Pushtah Aim: Get +6\" Range for \"Jezzails\" and \"Rifles\" when in or in contact with COVER",
              "description": ""
            }
          ],
          "skills": [],
          "itemTemplateIds": []
        },
        {
          "id": "u2y45j9fz",
          "templateName": "Sultanate Assassin (0-2)",
          "name": "Sultanate Assassin",
          "class": "Sultanate Assassin",
          "type": "elite",
          "cost": 85,
          "costCurrency": "ducats",
          "stats": {
            "movement": 6,
            "melee": 2,
            "ranged": 1,
            "baseArmour": 0,
            "finalArmour": 0
          },
          "keywords": [
            "SULTANATE",
            "ELITE",
            "INFILTRATOR"
          ],
          "abilities": [
            {
              "name": "Temporal Assassin: Charge two enemies, attack first target once, can attack second once and with off-hand.",
              "description": ""
            },
            {
              "name": "Time Slip: On failed enemy attack, redeploy within 6\" (>1\" from enemies). If within distance of BLAST or SCATTER, misses count.",
              "description": ""
            }
          ],
          "skills": [],
          "itemTemplateIds": []
        },
        {
          "id": "9015ecrbg",
          "templateName": "Master Assassin (1)",
          "name": "Master Assassin",
          "class": "Master Assassin",
          "type": "elite",
          "cost": 95,
          "costCurrency": "ducats",
          "stats": {
            "movement": 6,
            "melee": 2,
            "ranged": 1,
            "baseArmour": 0,
            "finalArmour": 0
          },
          "keywords": [
            "INFILTRATOR",
            "LEADER",
            "TOUGH",
            "IRON SULTANATE"
          ],
          "abilities": [
            {
              "name": "Time Slip: On failed enemy attack, redeploy within 6\" (>1\" from enemies). If within distance of BLAST or SCATTER, misses count.",
              "description": ""
            },
            {
              "name": "Temporal Assassin: Charge two enemies, attack first target once, can attack second once and with off-hand.",
              "description": ""
            }
          ],
          "skills": [],
          "itemTemplateIds": []
        },
        {
          "id": "10gjamkzl",
          "templateName": "Dervish (0-4)",
          "name": "Dervish",
          "class": "Dervish",
          "type": "trooper",
          "cost": 55,
          "costCurrency": "ducats",
          "stats": {
            "movement": 6,
            "melee": 1,
            "ranged": 1,
            "baseArmour": 0,
            "finalArmour": 0
          },
          "keywords": [
            "IRON SULTANATE"
          ],
          "abilities": [
            {
              "name": "Agile: Gets +1 DICE to Dash ACTIONS.",
              "description": ""
            },
            {
              "name": "Whirling Dervish: Gets the IGNORE OFF-HAND WEAPON Keyword.",
              "description": ""
            },
            {
              "name": "Hypnotic Dance: Enemies get -1 DICE for Melee Attacks against a Dervish.",
              "description": ""
            }
          ],
          "skills": [],
          "itemTemplateIds": []
        },
        {
          "id": "uojchw0xk",
          "templateName": "Assassin Acolyte (0-3)",
          "name": "Assassin Acolyte",
          "class": "Azeb",
          "type": "trooper",
          "cost": 35,
          "costCurrency": "ducats",
          "stats": {
            "movement": 6,
            "melee": -1,
            "ranged": 0,
            "baseArmour": 0,
            "finalArmour": 0
          },
          "keywords": [
            "SULTANATE"
          ],
          "abilities": [
            "Light Skirmishers: +5 👑 each for SKIRMISHER."
          ],
          "skills": [],
          "itemTemplateIds": []
        }
      ],
      itemTemplates: [
        {
          "id": "z3o25jwhx",
          "templateName": "Assassin's Dagger (Premade)",
          "name": "Assassin's Dagger",
          "category": "melee",
          "keywords": [
            "+1 INJURY MODIFIER",
            "CRITICAL"
          ],
          "range": "",
          "armourModifier": "",
          "notes": "Assassin only\nSlashing Attack: On BLOOD MARKER, can Dash Retreat. Enemies can't Opportunity Attack on Retreat.",
          "cost": 15,
          "costCurrency": "ducats"
        },
        {
          "id": "vmtvp1gv4",
          "templateName": "Bayonet (Premade)",
          "name": "Bayonet",
          "category": "melee",
          "keywords": [
            "CUMBERSOME"
          ],
          "range": "",
          "armourModifier": "",
          "notes": "Shield Combo",
          "cost": 2,
          "costCurrency": "ducats"
        },
        {
          "id": "w0cbenub0",
          "templateName": "Great Hammer/Maul (Premade)",
          "name": "Great Hammer/Maul",
          "category": "melee",
          "keywords": [
            "+1 INJURY MODIFIER",
            "HEAVY"
          ],
          "range": "",
          "armourModifier": "",
          "notes": "",
          "cost": 10,
          "costCurrency": "ducats"
        },
        {
          "id": "qxi53kbwq",
          "templateName": "Great Sword/Axe (Premade)",
          "name": "Great Sword/Axe",
          "category": "melee",
          "keywords": [
            "+1 INJURY DICE",
            "CRITICAL",
            "HEAVY"
          ],
          "range": "",
          "armourModifier": "",
          "notes": "",
          "cost": 12,
          "costCurrency": "ducats"
        },
        {
          "id": "t0893dngt",
          "templateName": "Halberd-Gun (Premade)",
          "name": "Halberd-Gun",
          "category": "melee",
          "keywords": [
            "ASSAULT",
            "BLOCK",
            "CUMBERSOME"
          ],
          "range": "Melee/24\"",
          "armourModifier": "",
          "notes": "ELITE only",
          "cost": 20,
          "costCurrency": "ducats"
        },
        {
          "id": "ex4hco2a3",
          "templateName": "Polearm (Premade)",
          "name": "Polearm",
          "category": "melee",
          "keywords": [
            "BLOCK",
            "CUMBERSOME"
          ],
          "range": "",
          "armourModifier": "",
          "notes": "Shield Combo",
          "cost": 7,
          "costCurrency": "ducats"
        },
        {
          "id": "ezqci3sfj",
          "templateName": "Sword/Axe (Premade)",
          "name": "Sword/Axe",
          "category": "melee",
          "keywords": [
            "CRITICAL"
          ],
          "range": "",
          "armourModifier": "",
          "notes": "",
          "cost": 4,
          "costCurrency": "ducats"
        },
        {
          "id": "379vptp1u",
          "templateName": "Trench Club (Premade)",
          "name": "Trench Club",
          "category": "melee",
          "keywords": [],
          "range": "",
          "armourModifier": "",
          "notes": "",
          "cost": 3,
          "costCurrency": "ducats"
        },
        {
          "id": "3c6vdcfo7",
          "templateName": "Trench Knife (Premade)",
          "name": "Trench Knife",
          "category": "melee",
          "keywords": [
            "-1 DICE"
          ],
          "range": "",
          "armourModifier": "",
          "notes": "",
          "cost": 1,
          "costCurrency": "ducats"
        },
        {
          "id": "ztyyzk0ge",
          "templateName": "Flamethrower (Premade)",
          "name": "Flamethrower",
          "category": "ranged",
          "keywords": [
            "-1 INJURY DICE",
            "FIRE",
            "FLAMETHROWER",
            "IGNORE ARMOUR"
          ],
          "range": "8\"",
          "cost": 30,
          "costCurrency": "ducats",
          "notes": "Limit: 3"
        },
        {
          "id": "tst7lrp6u",
          "templateName": "Jezzail (Premade)",
          "name": "Jezzail",
          "category": "ranged",
          "keywords": [],
          "range": "18\"",
          "cost": 7,
          "costCurrency": "ducats",
          "notes": ""
        },
        {
          "id": "3115mb13a",
          "templateName": "Machine Gun (Premade)",
          "name": "Machine Gun",
          "category": "ranged",
          "keywords": [
            "AUTOMATIC 3",
            "HEAVY",
            "RELOAD"
          ],
          "range": "36\"",
          "cost": 50,
          "costCurrency": "ducats",
          "notes": "Limit: 1"
        },
        {
          "id": "cemus67nz",
          "templateName": "Musket (Premade)",
          "name": "Musket",
          "category": "ranged",
          "keywords": [
            "-1 INJURY DICE"
          ],
          "range": "18\"",
          "cost": 5,
          "costCurrency": "ducats",
          "notes": "Bayonet Lug"
        },
        {
          "id": "ej2ttyo5m",
          "templateName": "Pistol (Premade)",
          "name": "Pistol",
          "category": "ranged",
          "keywords": [
            "PISTOL"
          ],
          "range": "12\"/Melee",
          "cost": 6,
          "costCurrency": "ducats",
          "notes": ""
        },
        {
          "id": "ujmj4u3ta",
          "templateName": "Shotgun (Premade)",
          "name": "Shotgun",
          "category": "ranged",
          "keywords": [
            "+1 DICE",
            "SHOTGUN"
          ],
          "range": "12\"",
          "cost": 10,
          "costCurrency": "ducats",
          "notes": "Bayonet Lug, Shield Combo"
        },
        {
          "id": "bt4qm1z2r",
          "templateName": "Siege Jezzail (Premade)",
          "name": "Siege Jezzail",
          "category": "ranged",
          "keywords": [
            "+1 INJURY DICE",
            "HEAVY"
          ],
          "range": "30\"",
          "cost": 30,
          "costCurrency": "ducats",
          "notes": ""
        },
        {
          "id": "phkmaikew",
          "templateName": "Alchemist Armour (Premade)",
          "name": "Alchemist Armour",
          "category": "armour",
          "keywords": [
            "NEGATE FIRE",
            "NEGATE GAS"
          ],
          "range": "",
          "armourModifier": "-2 INJURY MODIFIER",
          "notes": "ELITE only, Limit: 1\nProtection From Harm: -1 INJURY DICE vs FIRE/GAS (even IGNORE ARMOUR).",
          "cost": 50,
          "costCurrency": "ducats"
        },
        {
          "id": "gg3hsrwhn",
          "templateName": "Reinforced Armour (Premade)",
          "name": "Reinforced Armour",
          "category": "armour",
          "keywords": [],
          "range": "",
          "armourModifier": "-2 INJURY MODIFIER",
          "notes": "ELITE & Janissaries only",
          "cost": 40,
          "costCurrency": "ducats"
        },
        {
          "id": "pa9ogdl8e",
          "templateName": "Standard Armour (Premade)",
          "name": "Standard Armour",
          "category": "armour",
          "keywords": [],
          "range": "",
          "armourModifier": "-1 INJURY MODIFIER",
          "notes": "",
          "cost": 15,
          "costCurrency": "ducats"
        },
        {
          "id": "ps85pb3kj",
          "templateName": "Trench Shield (Premade)",
          "name": "Trench Shield",
          "category": "shield",
          "keywords": [],
          "range": "",
          "armourModifier": "-1 INJURY MODIFIER",
          "notes": "Shield Combo",
          "cost": 10,
          "costCurrency": "ducats"
        },
        {
          "id": "726szxfol",
          "templateName": "Frag Grenades (Premade)",
          "name": "Frag Grenades",
          "category": "grenade",
          "keywords": [
            "ASSAULT",
            "BLAST 2\"",
            "IGNORE COVER",
            "IGNORE LONG RANGE",
            "SHRAPNEL"
          ],
          "range": "8\"",
          "armourModifier": "",
          "notes": "",
          "cost": 7,
          "costCurrency": "ducats"
        },
        {
          "id": "wvfr5dg57",
          "templateName": "Incendiary Grenades (Premade)",
          "name": "Incendiary Grenades",
          "category": "grenade",
          "keywords": [
            "ASSAULT",
            "FIRE",
            "IGNORE COVER",
            "IGNORE LONG RANGE"
          ],
          "range": "8\"",
          "armourModifier": "",
          "notes": "Alchemist Only\nLiquid Fire: Critical Success Injury Roll gains IGNORE ARMOUR.",
          "cost": 15,
          "costCurrency": "ducats"
        },
        {
          "id": "ybw8dped8",
          "templateName": "Alchemical Ammunition (Premade)",
          "name": "Alchemical Ammunition",
          "category": "equipment",
          "keywords": [],
          "range": "",
          "armourModifier": "",
          "notes": "Models with Jezzail, Siege Jezzail, Alaybozan or Halberd-Gun only\nGuiding Path: +1 DICE to Ranged Attacks with those weapons.",
          "cost": 3,
          "costCurrency": "ducats"
        },
        {
          "id": "pjptiapav",
          "templateName": "Binoculars (Premade)",
          "name": "Binoculars",
          "category": "equipment",
          "keywords": [],
          "range": "",
          "armourModifier": "",
          "notes": "ELITE only\nBinoculars: INFILTRATOR cannot deploy within 16\" unless in own zone.",
          "cost": 10,
          "costCurrency": "ducats"
        },
        {
          "id": "8kq3aetkr",
          "templateName": "Combat Helmet (Premade)",
          "name": "Combat Helmet",
          "category": "equipment",
          "keywords": [
            "NEGATE SHRAPNEL"
          ],
          "range": "",
          "armourModifier": "",
          "notes": "",
          "cost": 5,
          "costCurrency": "ducats"
        },
        {
          "id": "r1keyvahm",
          "templateName": "Gas Mask (Premade)",
          "name": "Gas Mask",
          "category": "equipment",
          "keywords": [
            "NEGATE GAS"
          ],
          "range": "",
          "armourModifier": "",
          "notes": "",
          "cost": 5,
          "costCurrency": "ducats"
        },
        {
          "id": "xfwge2d5d",
          "templateName": "Holy Relic (Premade)",
          "name": "Holy Relic",
          "category": "equipment",
          "keywords": [
            "BLESSED 1"
          ],
          "range": "",
          "armourModifier": "",
          "notes": "ELITE only",
          "cost": 2,
          "costCurrency": "glory"
        },
        {
          "id": "i0v6eghcb",
          "templateName": "Medi-kit (Premade)",
          "name": "Medi-kit",
          "category": "equipment",
          "keywords": [],
          "range": "",
          "armourModifier": "",
          "notes": "Treat ACTION: Risky Success to remove BLOOD MARKER or stand up Down model within 1\".",
          "cost": 5,
          "costCurrency": "ducats"
        },
        {
          "id": "leeai44a3",
          "templateName": "Mountaineer Kit (Premade)",
          "name": "Mountaineer Kit",
          "category": "equipment",
          "keywords": [],
          "range": "",
          "armourModifier": "",
          "notes": "Limit: 2\n+1 DICE to climb sheer surfaces.",
          "cost": 3,
          "costCurrency": "ducats"
        },
        {
          "id": "vbfvyuuea",
          "templateName": "Musical Instrument (Premade)",
          "name": "Musical Instrument",
          "category": "equipment",
          "keywords": [
            "HELD"
          ],
          "range": "",
          "armourModifier": "",
          "notes": "Limit: 1\n+1 DICE to Dash for friendly within 4\".",
          "cost": 15,
          "costCurrency": "ducats"
        },
        {
          "id": "n9jjmzags",
          "templateName": "Shovel (Premade)",
          "name": "Shovel",
          "category": "equipment",
          "keywords": [],
          "range": "",
          "armourModifier": "",
          "notes": "COVER on Open terrain until move. Can use as 2-Handed Melee.",
          "cost": 5,
          "costCurrency": "ducats"
        },
        {
          "id": "xy86h0foj",
          "templateName": "Takwin Anqā Bird (Premade)",
          "name": "Takwin Anqā Bird",
          "category": "equipment",
          "keywords": [],
          "range": "",
          "armourModifier": "",
          "notes": "ELITE only, Limit: 1\nCause Confusion: Melee Success Rolls vs model become Risky. Enemy within 1\" must Risky Success to Retreat.",
          "cost": 2,
          "costCurrency": "glory"
        },
        {
          "id": "frdns6k6v",
          "templateName": "Troop Flag (Premade)",
          "name": "Troop Flag",
          "category": "equipment",
          "keywords": [
            "LEADER",
            "HELD"
          ],
          "range": "",
          "armourModifier": "",
          "notes": "Limit: 1",
          "cost": 1,
          "costCurrency": "glory"
        },
        {
          "id": "oeq7hvtp8",
          "templateName": "Wind Amulet (Premade)",
          "name": "Wind Amulet",
          "category": "equipment",
          "keywords": [],
          "range": "",
          "armourModifier": "",
          "notes": "Limit: 2\nGusts of Wind: Once per game, +3\" Movement for activation.",
          "cost": 10,
          "costCurrency": "ducats"
        },
        {
          "id": "r4ua4a54",
          "templateName": "Sniper Rifle (Modified)",
          "name": "Sniper Rifle",
          "category": "ranged",
          "keywords": [
            "+1 DICE",
            "CRITICAL",
            "RISKY"
          ],
          "range": "48\"",
          "cost": 35,
          "costCurrency": "ducats",
          "notes": "ELITE & Pashtun Marksmen only, Limit: 2\nBull's Eye: Critical Success Injury Roll gains IGNORE ARMOUR."
        },
        {
          "id": "te79ottbr",
          "templateName": "Cloak of Alamut (Modified)",
          "name": "Cloak of Alamut",
          "category": "equipment",
          "keywords": [],
          "range": "",
          "armourModifier": "",
          "notes": "ELITE only\nBlend in: -1 DICE for enemy ranged attacks when in or contact with COVER.",
          "cost": 15,
          "costCurrency": "ducats"
        },
        {
          "id": "x0j2qpojl",
          "templateName": "Golden Khanjar",
          "name": "Golden Khanjar",
          "category": "melee",
          "keywords": [
            "+1 INJURY MODIFIER"
          ],
          "range": "",
          "armourModifier": "",
          "notes": "Master Assassins & Sultanate Assassins only, Limit: 2\n\nAttack Twice: You can make two Melee Attacks with this Weapon.",
          "cost": 20,
          "costCurrency": "ducats"
        },
        {
          "id": "3ldhjchfx",
          "templateName": "Hashashin Leaf",
          "name": "Hashashin Leaf",
          "category": "equipment",
          "keywords": [
            "NEGATE FEAR"
          ],
          "range": "",
          "armourModifier": "",
          "notes": "Limit: 4, CONSUMABLE\n\nEnhanced Senses: NEGATE FEAR and gain STRONG until the end of the game.",
          "cost": 5,
          "costCurrency": "ducats"
        },
        {
          "id": "jpkh0q37p",
          "templateName": "Iron Ammunition",
          "name": "Iron Ammunition",
          "category": "equipment",
          "keywords": [],
          "range": "",
          "armourModifier": "",
          "notes": "Models with Jezzail, Siege Jezzail, Alaybozan or Halberd-Gun only, Limit: 2\nIron Hardness: Ranged Attacks with those weapons get ARMOR PIERCING.",
          "cost": 5,
          "costCurrency": "ducats"
        },
        {
          "id": "ffug3pcy2",
          "templateName": "Bow of Alamut",
          "name": "Bow of Alamut",
          "category": "ranged",
          "keywords": [
            "IGNORE ARMOUR",
            "CRITICAL"
          ],
          "range": "40\"",
          "armourModifier": "",
          "notes": "Master Assassin and Sultantate Assassin only, Limit: 1\nTemporal Slipstream: When causing at least one BLOOD MARKER, teleport into base contact with the target. You can then make a Fight ACTION. ",
          "cost": 50,
          "costCurrency": "ducats"
        },
        {
          "id": "v493r0frh",
          "templateName": "Alamut Eagle",
          "name": "Alamut Eagle",
          "category": "equipment",
          "keywords": [],
          "range": "",
          "armourModifier": "",
          "notes": "ELITE only, Limit: 1\nDistract ACTION: Make success roll with +1 DICE against enemy in melee. If successful, give 1 BLOOD MARKER unless NEGATE SHRAPNEL and Assassin can retreat with Dash and can retreat without provoking opportunity attacks.\n",
          "cost": 2,
          "costCurrency": "glory"
        },
        {
          "id": "cgnnaaa65",
          "templateName": "Smoke Bomb",
          "name": "Smoke Bomb",
          "category": "equipment",
          "keywords": [],
          "range": "",
          "armourModifier": "",
          "notes": "Consumable, Limit: 1\nObscuring Smoke: Place a smoke token up to 6\" away from your deployment zone. Create Smoke effect within 4\" of the center of the marker. Ranged attacks passing through the effect gain -1 DICE to hit.",
          "cost": 2,
          "costCurrency": "glory"
        }
      ]
    }
  },
  {
    name: "Ghazi of the Golden Path (Sultanate Subfaction)",
  // link: "https://your-link-here.com", // Optional
  data: {
    modelTemplates: [
      {
        "id": "ghazi001yuzbasi",
        "templateName": "Yuzbasi Captain (Standard Leader)",
        "name": "Yuzbasi Captain",
        "class": "SULTANATE LEADER",
        "type": "elite",
        "cost": 80,
        "costCurrency": "ducats",
        "stats": {
          "movement": 6,
          "melee": 2,
          "ranged": 1,
          "baseArmour": 0,
          "finalArmour": 0
        },
        "keywords": ["SULTANATE", "ELITE", "LEADER"],
        "abilities": [
          {
            "name": "Struggle by the Sword",
            "description": "When this model takes an enemy with ELITE or TOUGH Out of Action → gain 1 BLESSING MARKER"
          },
          "Mubarizun or other standard Yuzbasi abilities here (as per core)"
        ],
        "skills": [],
        "itemTemplateIds": [],
        "upgrades": [],
        "limit": 1
      },
      {
        "id": "ghazi002akinjibey",
        "templateName": "Akinji-Bey (Optional Leader)",
        "name": "Akinji-Bey",
        "class": "SULTANATE LEADER",
        "type": "elite",
        "cost": 80,
        "costCurrency": "ducats",
        "stats": {
          "movement": 6,
          "melee": 2,
          "ranged": 1,
          "baseArmour": 0,
          "finalArmour": 0
        },
        "keywords": ["SULTANATE", "ELITE", "LEADER"],
        "abilities": [
          {
            "name": "Struggle by the Sword",
            "description": "When this model takes an enemy with ELITE or TOUGH Out of Action → gain 1 BLESSING MARKER"
          },
          {
            "name": "Guiding Strike",
            "description": "First time this model deals a BLOOD MARKER to an enemy: all friendly attacks vs that enemy +1 DICE to hit until end of round."
          }
        ],
        "skills": [],
        "itemTemplateIds": [],
        "upgrades": []
      },
      {
        "id": "ghazi003akinji",
        "templateName": "Akinji",
        "name": "Akinji",
        "class": "Akinji",
        "type": "trooper",
        "cost": 25,
        "costCurrency": "ducats",
        "stats": {
          "movement": 6,
          "melee": 0,
          "ranged": 0,
          "baseArmour": 0,
          "finalArmour": 0
        },
        "keywords": ["SULTANATE"],
        "abilities": [
          {
            "name": "Struggle by the Sword",
            "description": "When this model takes an enemy with ELITE or TOUGH Out of Action → gain 1 BLESSING MARKER"
          }
        ],
        "skills": [],
        "itemTemplateIds": [],
        "upgrades": [
          {
            "id": "ghazi_cekilmek",
            "name": "Çekilmek Upgrade",
            "cost": 10,
            "effect": {
              "type": "add_abilities",
              "abilities": [
                {
                  "name": "Çekilmek",
                  "description": "Reaction (once/round): Enemy ends activation within 8\" (not in melee) → move up to half movement any direction. Retreat attacks vs this model -1 DICE."
                }
              ]
            }
          }
        ],
        "limit": 6
      },
      {
        "id": "ghazi004gunahkar",
        "templateName": "Günahkâr",
        "name": "Günahkâr",
        "class": "Günahkâr",
        "type": "trooper",
        "cost": 35,
        "costCurrency": "ducats",
        "stats": {
          "movement": 6,
          "melee": 1,
          "ranged": 0,
          "baseArmour": 0,
          "finalArmour": 0
        },
        "keywords": ["SULTANATE", "NEGATE FEAR"],
        "abilities": [
          {
            "name": "Struggle by the Sword",
            "description": "When this model takes an enemy with ELITE or TOUGH Out of Action → gain 1 BLESSING MARKER"
          },
          {
            "name": "Djinn Hunter",
            "description": "Immune to FEAR"
          }
        ],
        "skills": [],
        "itemTemplateIds": [],
        "upgrades": [],
        "limit": 4
      },
      {
        "id": "ghazi005abrek",
        "templateName": "Abrek Pioneer",
        "name": "Abrek Pioneer",
        "class": "Abrek Pioneer",
        "type": "trooper",
        "cost": 55,
        "costCurrency": "ducats",
        "stats": {
          "movement": 6,
          "melee": 1,
          "ranged": 0,
          "baseArmour": 0,
          "finalArmour": 0
        },
        "keywords": ["SULTANATE"],
        "abilities": [
          {
            "name": "Struggle by the Sword",
            "description": "When this model takes an enemy with ELITE or TOUGH Out of Action → gain 1 BLESSING MARKER"
          },
          {
            "name": "Improvised Trap ACTION",
            "description": "Success +2 DICE: Place 2\" trap marker in base contact. Enemy within 1\" → immediate Injury Roll. DOWN = pinned (RISKY to stand/move next turn). STRONG or ≥50mm +1 DICE. Abreks ignore own traps."
          }
        ],
        "skills": [],
        "itemTemplateIds": [],
        "upgrades": []
      },
      {
        "id": "ghazi006tegmen",
        "templateName": "Teğmen",
        "name": "Teğmen",
        "class": "Teğmen",
        "type": "elite",
        "cost": 60,
        "costCurrency": "ducats",
        "stats": {
          "movement": 6,
          "melee": 2,
          "ranged": 1,
          "baseArmour": 0,
          "finalArmour": 0
        },
        "keywords": ["SULTANATE", "ELITE"],
        "abilities": [
          {
            "name": "Struggle by the Sword",
            "description": "When this model takes an enemy with ELITE or TOUGH Out of Action → gain 1 BLESSING MARKER"
          },
          {
            "name": "Counterattack",
            "description": "Reaction: Enemy misses Teğmen or friendly within 1\" in melee → single melee attack back"
          },
          "Choose ONE permanent Martial Discipline at hiring:",
          {
            "name": "Mubarak",
            "description": "Injury Rolls vs this model -1 DICE"
          },
          {
            "name": "Deliler",
            "description": "+1 DICE to DASH, gains FEAR"
          },
          {
            "name": "Pahlavan",
            "description": "Gains STRONG. BLOOD MARKERS cannot penalise ACTIONS"
          }
        ],
        "skills": [],
        "itemTemplateIds": [],
        "upgrades": [],
        "limit": 2
      },
      {
        "id": "ghazi007shirdal",
        "templateName": "Shirdal",
        "name": "Shirdal",
        "class": "Shirdal",
        "type": "elite",
        "cost": 140,
        "costCurrency": "ducats",
        "stats": {
          "movement": 8,
          "melee": 2,
          "ranged": 0,
          "baseArmour": -2,
          "finalArmour": -2
        },
        "keywords": ["SULTANATE", "FEAR", "TOUGH"],
        "abilities": [
          {
            "name": "Struggle by the Sword",
            "description": "When this model takes an enemy with ELITE or TOUGH Out of Action → gain 1 BLESSING MARKER"
          },
          "Reinforced Armour + Wind Amulet included",
          {
            "name": "Chimeric Vitality",
            "description": "Injury Rolls vs this model -1 DICE unless FIRE/GAS"
          },
          {
            "name": "Damascus Talons",
            "description": "Main attack: +2 flat Injury"
          },
          {
            "name": "Crushing Beak",
            "description": "Off-hand: +1 DICE Injury (Off-Hand penalty)"
          },
          {
            "name": "Winged Beast",
            "description": "+1 DICE DASH/Diving Charge"
          }
        ],
        "skills": [],
        "itemTemplateIds": [],
        "upgrades": [],
        "limit": 1
      },
      {
        "id": "ghazi008pairika",
        "templateName": "Pairika",
        "name": "Pairika",
        "class": "Pairika",
        "type": "elite",
        "cost": 7,
        "costCurrency": "glory",
        "stats": {
          "movement": 6,
          "melee": 1,
          "ranged": 0,
          "baseArmour": 0,
          "finalArmour": 0
        },
        "keywords": ["SULTANATE", "FEAR", "TOUGH"],
        "abilities": [
          {
            "name": "Struggle by the Sword",
            "description": "When this model takes an enemy with ELITE or TOUGH Out of Action → gain 1 BLESSING MARKER"
          },
          "Combat Helmet + Bident (Polearm) included",
          {
            "name": "Bident",
            "description": "As Trench Polearm + +1 DICE Injury vs DEMONIC/HERETIC/BLACK GRAIL"
          },
          {
            "name": "Nur Crest RISKY ACTION",
            "description": "Friendly within 3\": Success remove 1 Blood/Infection; Critical up to 3"
          },
          {
            "name": "His Mercy",
            "description": "Once/round: Friendly (not self) Injury → set one die to 1"
          },
          {
            "name": "Celestial Vitality",
            "description": "Injury Rolls vs this model -2 DICE"
          }
        ],
        "skills": [],
        "itemTemplateIds": [],
        "upgrades": [],
        "limit": 1
      }
    ],
    itemTemplates: [
      {
        "id": "ghazi_chainkura",
        "templateName": "Chain Kura",
        "name": "Chain Kura",
        "category": "ranged",
        "keywords": ["ASSAULT", "CONSUMABLE", "IGNORE RANGE", "IGNORE COVER"],
        "range": "8\"",
        "armourModifier": "",
        "notes": "1-Handed. Minor Injury → DOWN instead. Single use ranged. Limit 4.",
        "cost": 10,
        "costCurrency": "ducats",
        "limit": 4
      },
      {
        "id": "ghazi_khyber",
        "templateName": "Khyber Knife",
        "name": "Khyber Knife",
        "category": "melee",
        "keywords": ["ARMOR PIERCING", "CRITICAL"],
        "range": "",
        "armourModifier": "",
        "notes": "1-Handed. Injury → +1 extra BLOOD MARKER.",
        "cost": 8,
        "costCurrency": "ducats"
      },
      {
        "id": "ghazi_anaza",
        "templateName": "Anaza Spear",
        "name": "Anaza Spear",
        "category": "melee",
        "keywords": ["CUMBERSOME", "SHIELD COMBO", "IGNORE ARMOR", "BLOCK"],
        "range": "",
        "armourModifier": "",
        "notes": "2-Handed. ELITE only, Limit 1. IGNORE ARMOR on Injury. +1 DICE Injury vs DOWN.",
        "cost": 30,
        "costCurrency": "ducats",
        "limit": 1,
        "restrictions": ["ELITE only"]
      },
      {
        "id": "ghazi_scrapshot",
        "templateName": "Scrap Shot",
        "name": "Scrap Shot",
        "category": "equipment",
        "keywords": ["ARMOR PIERCING"],
        "range": "",
        "armourModifier": "",
        "notes": "Adds ARMOR PIERCING to compatible ranged weapons. Replaces Alchemical Ammo.",
        "cost": 5,
        "costCurrency": "ducats"
      },
      {
        "id": "ghazi_banner",
        "templateName": "Banner of the Eagle",
        "name": "Banner of the Eagle",
        "category": "equipment",
        "keywords": ["LEADER", "HELD"],
        "range": "",
        "armourModifier": "",
        "notes": "Limit 1. As Troop Flag + friendly within 6\" ignore FEAR.",
        "cost": 35,
        "costCurrency": "ducats",
        "limit": 1
      },
      {
        "id": "ghazi_marid",
        "templateName": "Marid Pelt",
        "name": "Marid Pelt",
        "category": "equipment",
        "keywords": ["INFILTRATOR"],
        "range": "",
        "armourModifier": "",
        "notes": "Günahkâr only. Non-BLAST attacks vs model -1 DICE hit.",
        "cost": 25,
        "costCurrency": "ducats",
        "restrictions": ["Günahkâr only"]
      },
      {
        "id": "ghazi_kayanin",
        "templateName": "Kayanin Mace",
        "name": "Kayanin Mace",
        "category": "melee",
        "keywords": ["HEAVY", "CUMBERSOME", "+2 INJURY MODIFIER"],
        "range": "",
        "armourModifier": "",
        "notes": "2-Handed. ELITE only, Limit 1. +2 flat Injury. Vs Armoured: +SHRAPNEL +BLAST 2\".",
        "cost": 2,
        "costCurrency": "glory",
        "limit": 1,
        "restrictions": ["ELITE only"]
      },
      {
        "id": "ghazi_abus",
        "templateName": "Abus Gun",
        "name": "Abus Gun",
        "category": "ranged",
        "keywords": ["ARMOR PIERCING", "HEAVY", "+2 DICE"],
        "range": "30\"",
        "armourModifier": "",
        "notes": "2-Handed. Limit 2. Injury +2 DICE.",
        "cost": 3,
        "costCurrency": "glory",
        "limit": 2
      }
    ]
  }
},
  {
    name: "Knights of the Court",
    data: {
      modelTemplates: [
        {
          id: "f6cqli8os",
          templateName: "Profaned Templar",
          name: "Profaned Templar",
          class: "Profaned Templar",
          type: "elite",
          cost: 120,
          costCurrency: "ducats",
          stats: {
            movement: 6,
            melee: 2,
            ranged: 2,
            baseArmour: 0,
            finalArmour: 0
          },
          keywords: [
            "THE COURT",
            "ELITE",
            "LEADER",
            "TOUGH",
            "STRONG"
          ],
          abilities: [],
          skills: [],
          itemTemplateIds: [],
          upgrades: [],
          limit: 1,
          inbuiltEquipment: [
            {
              id: "mh9qro6li",
              name: "Infernal Iron Armour",
              category: "armour",
              keywords: [
                "IMPERVIOUS"
              ],
              armourModifier: "-2"
            }
          ]
        },
        {
          id: "6mmm1kmjz",
          templateName: "Knight",
          name: "Knight",
          class: "Knight",
          type: "elite",
          cost: 100,
          costCurrency: "ducats",
          stats: {
            movement: 6,
            melee: 2,
            ranged: 0,
            baseArmour: 0,
            finalArmour: 0
          },
          keywords: [],
          abilities: [],
          skills: [],
          itemTemplateIds: [],
          upgrades: [
            {
              id: "txbojo5so",
              name: "Charge of Hatred",
              cost: 0,
              limit: 1,
              effects: {
                addAbilities: [
                  {
                    name: "Charge of Hatred",
                    description: "Auto Charge 12\""
                  }
                ]
              }
            },
            {
              id: "qruz9sjoq",
              name: "Proud Defiance",
              cost: 5,
              limit: 1,
              effects: {
                addAbilities: [
                  {
                    name: "Proud Defiance",
                    description: "while Alive do not make Morale Checks"
                  }
                ]
              }
            },
            {
              id: "6x5epcfmu",
              name: "Charm of Acedia",
              cost: 10,
              limit: 1,
              effects: {
                addAbilities: [
                  {
                    name: "Charm of Acedia Cost 1",
                    description: "Cast Spell ACTION next ACTION is an automatic success"
                  }
                ]
              }
            },
            {
              "id": "85o88thw5",
              "name": "Coveted Position",
              "cost": 15,
              "limit": 1,
              "effects": {
                "addAbilities": [
                  {
                    "name": "Coveted Position Cost 2)",
                    "description": "Change places with a model within 12\", that is not within 1\" of another model"
                  }
                ]
              }
            },
            {
              id: "rvf1mmfum",
              name: "Belly of the beast",
              cost: 5,
              limit: 1,
              effects: {
                addAbilities: [
                  {
                    name: "Belly of the beast",
                    description: "Melee Attacks add an additional BLOOD MARKER when inflicting one"
                  }
                ]
              }
            },
            {
              id: "rvc38p9tq",
              name: "Call of the Flesh",
              cost: 10,
              limit: 1,
              effects: {
                addAbilities: [
                  {
                    name: "Call of the Flesh Cost 2",
                    description: "Cast Spell ACTION the Enemy must get as close"
                  }
                ]
              }
            },
            {
              id: "cx33uf452",
              name: "Body of gold",
              cost: 25,
              limit: 1,
              effects: {
                addKeywords: [
                  "GOLEM"
                ]
              }
            }
          ],
          limit: 5,
          inbuiltEquipment: [
            {
              id: "14age79sj",
              name: "Infernal Iron Armour",
              category: "armour",
              keywords: [],
              armourModifier: "-2"
            }
          ]
    },
    {
      "id": "9dlr40abf",
      "templateName": "Desecrated Saint",
      "name": "Desecrated Saint",
      "class": "Desecrated Saint",
      "type": "trooper",
      "cost": 140,
      "costCurrency": "ducats",
      "stats": {
        "movement": 6,
        "melee": 3,
        "ranged": 0,
        "baseArmour": -3,
        "finalArmour": -3
      },
      "keywords": [
        "THE COURT",
        "DEMONIC",
        "FEAR",
        "STRONG",
        "TOUGH"
      ],
      "abilities": [],
      "skills": [],
      "itemTemplateIds": [],
      "upgrades": [
        {
          "id": "265mhhs6x",
          "name": "Aura of Sloth",
          "cost": 0,
          "effects": {
            "addAbilities": [
              {
                "name": "Aura of Sloth",
                "description": "Enemy models within 8\" of this Desecrated Saint treat Minor Hit results as Down results."
              }
            ]
          }
        },
        {
          "id": "co1mw7lbn",
          "name": "Aura of Gluttoy",
          "cost": 0,
          "effects": {
            "addAbilities": [
              {
                "name": "Aura of Gluttoy",
                "description": " Add -1 DICE to rolls for enemy models within 8\" of this Desecrated Saint unless the enemy model has\nthe BLACK GRAIL or ARTIFICIAL Keyword."
              }
            ]
          }
        }
      ],
      "limit": 2
    },
    {
      "id": "oi5vxvxx4",
      "templateName": "Yoke Fiend",
      "name": "Yoke Fiend",
      "class": "Yoke Fiend",
      "type": "trooper",
      "cost": 30,
      "costCurrency": "ducats",
      "stats": {
        "movement": 6,
        "melee": 1,
        "ranged": 0,
        "baseArmour": 0,
        "finalArmour": 0
      },
      "keywords": [
        "THE COURT"
      ],
      "abilities": [],
      "skills": [],
      "itemTemplateIds": [],
      "upgrades": []
    },
    {
      "id": "xbqf3q1g5",
      "templateName": "Wretched",
      "name": "Wretched",
      "class": "Wretched",
      "type": "trooper",
      "cost": 20,
      "costCurrency": "ducats",
      "stats": {
        "movement": 6,
        "melee": 0,
        "ranged": 0,
        "baseArmour": 0,
        "finalArmour": 0
      },
      "keywords": [
        "THE COURT"
      ],
      "abilities": [],
      "skills": [],
      "itemTemplateIds": [],
      "upgrades": []
    },
    {
      "id": "pg7677hxp",
      "templateName": "Pit Locusts",
      "name": "Pit Locusts",
      "class": "Pit Locusts",
      "type": "trooper",
      "cost": 90,
      "costCurrency": "ducats",
      "stats": {
        "movement": 8,
        "melee": 2,
        "ranged": 0,
        "baseArmour": -2,
        "finalArmour": -2
      },
      "keywords": [
        "THE COURT",
        "DEMONIC",
        "FEAR",
        "FLYING"
      ],
      "abilities": [],
      "skills": [],
      "itemTemplateIds": [],
      "upgrades": [],
      "limit": 3
    }
  ],
  "itemTemplates": [
    {
      "id": "gy5f96bbz",
      "templateName": "Mancubus cannon",
      "name": "Mancubus cannon",
      "category": "ranged",
      "keywords": [
        "FIRE",
        "+1D TO HIT",
        "IGNORE COVER",
        "HEAVY",
        "+2 INJURY MODIFIER",
        "BLAST 2\"",
        "SCATTER",
        "GOETIC 1",
        "RELAOD"
      ],
      "range": "36/Melee",
      "armourModifier": "",
      "notes": "This weapon can only be carried by a saint. This weapon takes all 3 of the saints hands to hold. It can be used to smash an opponent in melee with a +2D to injury but does not do the flat +2. The cannon can only target models, regardless of blast keyword.",
      "cost": 55,
      "costCurrency": "ducats",
      "limit": 1
    },
    {
      "id": "1bacrazwu",
      "templateName": "Infernal rifle",
      "name": "Infernal rifle",
      "category": "ranged",
      "keywords": [
        "FIRE",
        "ASSAULT",
        "HEAVY",
        "AUTOMATIC 2"
      ],
      "range": "24",
      "armourModifier": "",
      "notes": "",
      "cost": 45,
      "costCurrency": "ducats",
      "limit": 2
    },
    {
      "id": "z2kmfy5ba",
      "templateName": "Blade of  Tormented souls",
      "name": "Blade of  Tormented souls",
      "category": "melee",
      "keywords": [
        "HEAVY"
      ],
      "range": "",
      "armourModifier": "",
      "notes": "When you make an attack with this weapon set on die to 5 and roll the other.\n",
      "cost": 15,
      "costCurrency": "ducats",
      "limit": 2
    },
    {
      "id": "91j9wpzn9",
      "templateName": "Ophidian Rifle",
      "name": "Ophidian Rifle",
      "category": "ranged",
      "keywords": [
        "HEAVY",
        "IGNORE LONG RANGE",
        "IGNORE COVER"
      ],
      "range": "30",
      "armourModifier": "",
      "notes": "Unnatural Inversion: Add +1 DICE to roll for attacks made with this weapon\nif the Cover or Long Range modifiers apply to the attack, instead of adding -1\nDICE. Note that this means you add +2 DICE to the roll if both modifiers\napply to the attack.",
      "cost": 25,
      "costCurrency": "ducats",
      "limit": 3
    },
    {
      "id": "5k5li4vws",
      "templateName": "Arquebus",
      "name": "Arquebus",
      "category": "ranged",
      "keywords": [
        "CUMBERSOME"
      ],
      "range": "18",
      "armourModifier": "",
      "notes": "Batter: A model that has an Arquebus can use it as a 2-Handed Melee Weapon.",
      "cost": 8,
      "costCurrency": "ducats"
    },
    {
      "id": "1v5uhcasi",
      "templateName": "Crown of Hellfire",
      "name": "Crown of Hellfire",
      "category": "equipment",
      "keywords": [],
      "range": "",
      "armourModifier": "",
      "notes": " Searing Flames: When a model with a Crown of Hellfire ends an Activation,\nplace 1 BLOOD MARKER next to each enemy model within 1” of the\nmodel with a Crown of Hellfire, except for enemy models that have the\nNEGATE FIRE Keyword",
      "cost": 15,
      "costCurrency": "ducats"
    },
    {
      "id": "146yivo9s",
      "templateName": "Hellblade",
      "name": "Hellblade",
      "category": "melee",
      "keywords": [
        "+1 INJURY DICE",
        "FIRE"
      ],
      "range": "",
      "armourModifier": "",
      "notes": "",
      "cost": 15,
      "costCurrency": "ducats",
      "limit": 3
    },
    {
      "id": "8av86gf4b",
      "templateName": "Great Sword/Axe (General)",
      "name": "Great Sword/Axe",
      "category": "melee",
      "keywords": [
        "2-HANDED",
        "+1 INJURY DICE",
        "CRITICAL",
        "HEAVY"
      ],
      "range": "Melee",
      "cost": 12,
      "costCurrency": "ducats",
      "notes": ""
    },
    {
      "id": "d0nv4yeey",
      "templateName": "Sword/Axe (General)",
      "name": "Sword/Axe",
      "category": "melee",
      "keywords": [
        "1-HANDED",
        "CRITICAL"
      ],
      "range": "Melee",
      "cost": 4,
      "costCurrency": "ducats",
      "notes": ""
    },
    {
      "id": "h9uftncvb",
      "templateName": "Trench Club (General)",
      "name": "Trench Club",
      "category": "melee",
      "keywords": [
        "1-HANDED"
      ],
      "range": "Melee",
      "cost": 3,
      "costCurrency": "ducats",
      "notes": ""
    },
    {
      "id": "pe7bkmvfk",
      "templateName": "Flamethrower (General)",
      "name": "Flamethrower",
      "category": "ranged",
      "keywords": [
        "2-HANDED",
        "-1 INJURY DICE",
        "FIRE",
        "FLAMETHROWER",
        "IGNORE ARMOUR"
      ],
      "range": "8\"",
      "cost": 30,
      "costCurrency": "ducats",
      "limit": 3,
      "notes": ""
    },
    {
      "id": "9mqopj7ed",
      "templateName": "Pistol (General)",
      "name": "Pistol",
      "category": "ranged",
      "keywords": [
        "1-HANDED",
        "PISTOL"
      ],
      "range": "12\"/Melee",
      "cost": 6,
      "costCurrency": "ducats",
      "notes": ""
    },
    {
      "id": "exstm2evi",
      "templateName": "Standard Armour (General)",
      "name": "Standard Armour",
      "category": "armour",
      "keywords": [],
      "armourModifier": "-1 INJURY MODIFIER",
      "cost": 15,
      "costCurrency": "ducats",
      "notes": ""
    },
    {
      "id": "dht3l7k4u",
      "templateName": "Reinforced Armour (General)",
      "name": "Reinforced Armour",
      "category": "armour",
      "keywords": [],
      "armourModifier": "-2 INJURY MODIFIER",
      "cost": 40,
      "costCurrency": "ducats",
      "notes": "ELITE & Mechanized Heavy Infantry only"
    },
    {
      "id": "pmqe8etc3",
      "templateName": "Trench Shield (General)",
      "name": "Trench Shield",
      "category": "shield",
      "keywords": [
        "Shield Combo"
      ],
      "armourModifier": "-1 INJURY MODIFIER",
      "cost": 10,
      "costCurrency": "ducats",
      "notes": ""
    },
    {
      "id": "pyds2zqoc",
      "templateName": "Gas Grenades (General)",
      "name": "Gas Grenades",
      "category": "grenade",
      "keywords": [
        "GRENADE",
        "-1 INJURY DICE",
        "ASSAULT",
        "BLAST 3\"",
        "GAS",
        "IGNORE ARMOUR",
        "IGNORE COVER",
        "IGNORE LONG RANGE"
      ],
      "range": "8\"",
      "cost": 10,
      "costCurrency": "ducats",
      "notes": ""
    },
    {
      "id": "2as1y6tg1",
      "templateName": "Incendiary Grenades (General)",
      "name": "Incendiary Grenades",
      "category": "grenade",
      "keywords": [
        "GRENADE",
        "ASSAULT",
        "FIRE",
        "IGNORE COVER",
        "IGNORE LONG RANGE"
      ],
      "range": "8\"",
      "cost": 15,
      "costCurrency": "ducats",
      "limit": 2,
      "notes": "Liquid Fire: If Success Roll is Critical Success, Injury Roll has IGNORE ARMOUR Keyword."
    },
    {
      "id": "vrv4b90hk",
      "templateName": "Combat Helmet (General)",
      "name": "Combat Helmet",
      "category": "equipment",
      "keywords": [
        "NEGATE SHRAPNEL",
        "Headgear"
      ],
      "cost": 5,
      "costCurrency": "ducats",
      "notes": ""
    },
    {
      "id": "tukiszi6g",
      "templateName": "Gas Mask (General)",
      "name": "Gas Mask",
      "category": "equipment",
      "keywords": [
        "NEGATE GAS"
      ],
      "cost": 5,
      "costCurrency": "ducats",
      "notes": ""
    },
    {
      "id": "em0mu923k",
      "templateName": "Incendiary Ammunition (General)",
      "name": "Incendiary Ammunition",
      "category": "equipment",
      "keywords": [
        "CONSUMABLE"
      ],
      "cost": 15,
      "costCurrency": "ducats",
      "limit": 1,
      "notes": "Incendiary: Choose 1 Ranged Weapon without BLAST, FIRE, GAS, or SHRAPNEL. Weapon gains FIRE Keyword."
    },
    {
      "id": "xcy12vpbf",
      "templateName": "Troop Flag (General)",
      "name": "Troop Flag",
      "category": "equipment",
      "keywords": [
        "LEADER",
        "HELD"
      ],
      "cost": 1,
      "costCurrency": "glory",
      "limit": 1,
      "notes": ""
    },
    {
      "id": "k3imn0yie",
      "templateName": "Unholy Relic (General)",
      "name": "Unholy Relic",
      "category": "equipment",
      "keywords": [
        "FEAR"
      ],
      "cost": 15,
      "costCurrency": "ducats",
      "notes": ""
    },
    {
      "id": "eq7z6xg4b",
      "templateName": "Unholy Trinket (General)",
      "name": "Unholy Trinket",
      "category": "equipment",
      "keywords": [
        "CONSUMABLE"
      ],
      "cost": 15,
      "costCurrency": "ducats",
      "notes": "Talisman: Once per game, when Risky Success Roll is Failure, can use trinket to prevent Activation from ending."
    }
  ]
    }
  },
  {
    name: "Synod of Strategic Prophecy",
    data: {
      modelTemplates: [
        {
          "id": "synod_tactician_host",
          "templateName": "Prophetic Tactician – Host (Synod)",
          "name": "Prophetic Tactician – Host",
          "class": "Prophetic Tactician",
          "type": "elite",
          "cost": 100,
          "costCurrency": "ducats",
          "stats": {
            "movement": 6,
            "melee": -1,
            "ranged": 1,
            "baseArmour": 0,
            "finalArmour": 0
          },
          "keywords": [
            "SYNOD",
            "ELITE",
            "LEADER",
            "WEAK"
          ],
          "abilities": [
            "WEAK: 1-Handed Weapons are treated as 2-Handed. 2-Handed Weapons gain HEAVY and cannot equip Equipment with the HEAVY Keyword.",
            "Gods Voice: When an Enemy comes within 1\" of this model they must make a Success roll. If that roll fails, they are taken Down. This does not end their turn if it happens on their turn.",
            "Corporal Mitosis: The Host and the Bud share a single soul. They always activate together as a Fire Team. If one body is taken Out of Action, convert the result to Down instead. The Prophetic Tactician is removed from play when both bodies have been taken Out of Action at least once.",
            "Note: The Host and Bud are separate models that must always be taken together. They do not share equipment."
          ],
          "skills": [],
          "itemTemplateIds": [],
          "upgrades": [],
          "limit": 1
        },
        {
          "id": "synod_tactician_bud",
          "templateName": "Prophetic Tactician – Bud (Synod)",
          "name": "Prophetic Tactician – Bud",
          "class": "Prophetic Tactician",
          "type": "elite",
          "cost": 0,
          "costCurrency": "ducats",
          "stats": {
            "movement": 8,
            "melee": 1,
            "ranged": 0,
            "baseArmour": 0,
            "finalArmour": 0
          },
          "keywords": [
            "SYNOD",
            "ELITE",
            "LEADER",
            "WEAK"
          ],
          "abilities": [
            "WEAK: 1-Handed Weapons are treated as 2-Handed. 2-Handed Weapons gain HEAVY and cannot equip Equipment with the HEAVY Keyword.",
            "Gods Voice: When an Enemy comes within 1\" of this model they must make a Success roll. If that roll fails, they are taken Down. This does not end their turn if it happens on their turn.",
            "Corporal Mitosis: The Host and the Bud share a single soul. They always activate together as a Fire Team. If one body is taken Out of Action, convert the result to Down instead. The Prophetic Tactician is removed from play when both bodies have been taken Out of Action at least once.",
            "Note: The Bud is always taken alongside the Host (free). They do not share equipment."
          ],
          "skills": [],
          "itemTemplateIds": [],
          "upgrades": [],
          "limit": 1
        },
        {
          "id": "synod_observer",
          "templateName": "Observer (Synod)",
          "name": "Observer",
          "class": "Observer",
          "type": "elite",
          "cost": 100,
          "costCurrency": "ducats",
          "stats": {
            "movement": 6,
            "melee": 2,
            "ranged": 0,
            "baseArmour": 0,
            "finalArmour": 0
          },
          "keywords": [
            "SYNOD",
            "ELITE",
            "NEGATE SHRAPNEL"
          ],
          "abilities": [
            "Eye of God: You can re-roll failed Success Rolls and Risky Success Rolls for an Observer. If you do so and any of the re-rolled dice show a 1, then the roll is treated as a Failure, the Observer is taken Down, and their Activation immediately ends.",
            "Lightning Speed: Any 2-Handed Melee weapon the Observer carries has the CLEAVE 2 and CUMBERSOME Keywords.",
            "Temporal Fugue: Add -1 DICE to rolls for Ranged Attacks and Melee Attacks that target an Observer.",
            "Voice of God RISKY ACTION: You must spend a Prophecy Dice when you use this ACTION.",
            "Note: An Observer always has a Combat Helmet equipped."
          ],
          "skills": [],
          "itemTemplateIds": [],
          "inbuiltEquipment": [
            {
              "id": "observer-helmet",
              "name": "Combat Helmet",
              "category": "equipment",
              "keywords": [
                "NEGATE SHRAPNEL"
              ],
              "notes": "Headgear"
            }
          ],
          "upgrades": [],
          "limit": 2
        },
        {
          "id": "synod_ark_bearer",
          "templateName": "Ark Bearer (Synod)",
          "name": "Ark Bearer",
          "class": "Ark Bearer",
          "type": "elite",
          "cost": 65,
          "costCurrency": "ducats",
          "stats": {
            "movement": 6,
            "melee": 2,
            "ranged": -2,
            "baseArmour": 0,
            "finalArmour": 0
          },
          "keywords": [
            "SYNOD",
            "ELITE"
          ],
          "abilities": [
            "Ark of the Signal: Choose one Frequency upgrade below when building your warband. All Ark Bearers and Receptors use the ability associated with the chosen Frequency."
          ],
          "skills": [],
          "itemTemplateIds": [],
          "upgrades": [
            {
              "id": "ark_bearer_freq1",
              "name": "Frequency 1: Ark of the Signal",
              "cost": 0,
              "limit": 1,
              "effects": {
                "addAbilities": [
                  "Freq 1: While this model is not Down, add +1 Injury Modifier to every Enemy Injury roll within 8\" of this model."
                ]
              }
            },
            {
              "id": "ark_bearer_freq2",
              "name": "Frequency 2: Ark of the Signal",
              "cost": 0,
              "limit": 1,
              "effects": {
                "addAbilities": [
                  "Freq 2 ACTION: Move an Ally D6\". Do not suffer Opportunity Attacks if this takes them out of melee."
                ]
              }
            },
            {
              "id": "ark_bearer_freq3",
              "name": "Frequency 3: Ark of the Signal",
              "cost": 0,
              "limit": 1,
              "effects": {
                "addAbilities": [
                  "Freq 3 ACTION: When the result is a Success or Critical Success, roll on the Injury table for every other model within 3\" of the Ark Bearer."
                ]
              }
            }
          ],
          "limit": 1
        },
        {
          "id": "synod_combat_medic",
          "templateName": "Combat Medic (Synod)",
          "name": "Combat Medic",
          "class": "Combat Medic",
          "type": "trooper",
          "cost": 65,
          "costCurrency": "ducats",
          "stats": {
            "movement": 6,
            "melee": 0,
            "ranged": 0,
            "baseArmour": -1,
            "finalArmour": -1
          },
          "keywords": [
            "SYNOD"
          ],
          "abilities": [
            "Expert Medic: Add +2 DICE to the Risky Success Roll when a Combat Medic carries out a Treat ACTION with their Medi-kit.",
            "Finish the Fallen: Add +1 INJURY DICE to Injury Rolls for Melee Attacks made by a Combat Medic if the target is Down and does not have the BLACK GRAIL or DEMONIC Keywords."
          ],
          "skills": [],
          "itemTemplateIds": [],
          "inbuiltEquipment": [
            {
              "id": "synod-medic-armour",
              "name": "Standard Armour",
              "category": "armour",
              "keywords": [],
              "armourModifier": "-1 INJURY MODIFIER",
              "notes": ""
            },
            {
              "id": "synod-medic-gasmask",
              "name": "Gas Mask",
              "category": "equipment",
              "keywords": [
                "NEGATE GAS"
              ],
              "notes": ""
            },
            {
              "id": "synod-medic-medikit",
              "name": "Medi-kit",
              "category": "equipment",
              "keywords": [],
              "notes": "Treat ACTION: Risky Success to remove BLOOD MARKER or stand up Down model within 1\"."
            },
            {
              "id": "synod-medic-misericordia",
              "name": "Misericordia",
              "category": "melee",
              "keywords": [],
              "range": "Melee",
              "notes": "Despatch: This weapon has the IGNORE ARMOUR Keyword if the target is Down."
            }
          ],
          "upgrades": [],
          "limit": 1
        },
        {
          "id": "synod_heavy_infantry",
          "templateName": "Sanctified Heavy Infantry (Synod)",
          "name": "Sanctified Heavy Infantry",
          "class": "Sanctified Heavy Infantry",
          "type": "trooper",
          "cost": 95,
          "costCurrency": "ducats",
          "stats": {
            "movement": 6,
            "melee": 0,
            "ranged": 1,
            "baseArmour": -2,
            "finalArmour": -2
          },
          "keywords": [
            "SYNOD",
            "NEGATE HEAVY",
            "NEGATE GAS"
          ],
          "abilities": [
            "Predictive Targeting: Discard 1 Prophecy Dice. This turn, when targeting an enemy in Melee combat add +2 to the result when determining if you hit your ally or the enemy.",
            "Orichalcum Battle Plate: Add -1 INJURY DICE to Injuries caused by Weapons with the BLAST Keyword."
          ],
          "skills": [],
          "itemTemplateIds": [],
          "upgrades": [],
          "limit": 3
        },
        {
          "id": "synod_receptor",
          "templateName": "Receptor (Synod)",
          "name": "Receptor",
          "class": "Receptor",
          "type": "trooper",
          "cost": 20,
          "costCurrency": "ducats",
          "stats": {
            "movement": 6,
            "melee": 0,
            "ranged": -1,
            "baseArmour": 0,
            "finalArmour": 0
          },
          "keywords": [
            "SYNOD",
            "WEAK"
          ],
          "abilities": [
            "WEAK: 1-Handed Weapons are treated as 2-Handed. 2-Handed Weapons gain HEAVY and cannot equip Equipment with the HEAVY Keyword.",
            "Choose either Sacrificial Pawn OR one Frequency Ability via upgrades below."
          ],
          "skills": [],
          "itemTemplateIds": [],
          "upgrades": [
            {
              "id": "receptor_sacrificial_pawn",
              "name": "Sacrificial Pawn",
              "cost": 0,
              "limit": 1,
              "effects": {
                "addAbilities": [
                  "Sacrificial Pawn: When a Synod Model within 1\" is taking an Injury roll you can divert it to this Receptor. Any Down result is converted to an Out of Action result."
                ]
              }
            },
            {
              "id": "receptor_freq1",
              "name": "Frequency 1: Ark of the Signal",
              "cost": 0,
              "limit": 1,
              "effects": {
                "addAbilities": [
                  "Freq 1: While this model has not Activated this turn, it and Synod Models within 1\" are -1 DICE to hit with Ranged Attacks."
                ]
              }
            },
            {
              "id": "receptor_freq2",
              "name": "Frequency 2: Ark of the Signal",
              "cost": 0,
              "limit": 1,
              "effects": {
                "addAbilities": [
                  "Freq 2: This model suffers an Out of Action result when suffering a Down result. Gain +1 DICE on any Dash Action and Melee Attack Action."
                ]
              }
            },
            {
              "id": "receptor_freq3",
              "name": "Frequency 3: Ark of the Signal",
              "cost": 0,
              "limit": 1,
              "effects": {
                "addAbilities": [
                  "Freq 3 ACTION: Remove this model from play and roll on the Injury Table for every model within 2\" with +1 DICE. (No Trauma roll.)"
                ]
              }
            }
          ]
        },
        {
          "id": "synod_observer_initiate",
          "templateName": "Observer Initiate (Synod)",
          "name": "Observer Initiate",
          "class": "Observer Initiate",
          "type": "trooper",
          "cost": 45,
          "costCurrency": "ducats",
          "stats": {
            "movement": 7,
            "melee": 1,
            "ranged": 0,
            "baseArmour": 0,
            "finalArmour": 0
          },
          "keywords": [
            "SYNOD"
          ],
          "abilities": [
            "Lightning Speed: Any 2-Handed Melee weapon the Observer Initiate carries has the CLEAVE 2 and CUMBERSOME Keywords."
          ],
          "skills": [],
          "itemTemplateIds": [],
          "upgrades": []
        }
      ],
      itemTemplates: [
        {
          "id": "synod_automatic_pistol",
          "templateName": "Automatic Pistol (Synod)",
          "name": "Automatic Pistol",
          "category": "ranged",
          "keywords": [
            "1-HANDED",
            "ASSAULT",
            "AUTOMATIC 2",
            "PISTOL"
          ],
          "range": "12\"/Melee",
          "cost": 20,
          "costCurrency": "ducats",
          "limit": 3,
          "notes": ""
        },
        {
          "id": "synod_automatic_rifle",
          "templateName": "Automatic Rifle (Synod)",
          "name": "Automatic Rifle",
          "category": "ranged",
          "keywords": [
            "2-HANDED",
            "ASSAULT",
            "AUTOMATIC 2",
            "Bayonet Lug"
          ],
          "range": "24\"",
          "cost": 40,
          "costCurrency": "ducats",
          "limit": 1,
          "notes": "Focused Fire: When this Weapon is used to make 2 Ranged Attacks, the same enemy model must be the target of both attacks."
        },
        {
          "id": "synod_automatic_shotgun",
          "templateName": "Automatic Shotgun (Synod)",
          "name": "Automatic Shotgun",
          "category": "ranged",
          "keywords": [
            "2-HANDED",
            "+1 DICE",
            "ASSAULT",
            "SHOTGUN",
            "Bayonet Lug",
            "Shield Combo"
          ],
          "range": "12\"",
          "cost": 12,
          "costCurrency": "ducats",
          "limit": 2,
          "notes": ""
        },
        {
          "id": "synod_bolt_action_rifle",
          "templateName": "Bolt-Action Rifle (Synod)",
          "name": "Bolt-Action Rifle",
          "category": "ranged",
          "keywords": [
            "2-HANDED",
            "Bayonet Lug"
          ],
          "range": "24\"",
          "cost": 10,
          "costCurrency": "ducats",
          "notes": ""
        },
        {
          "id": "synod_flamethrower",
          "templateName": "Flamethrower (Synod)",
          "name": "Flamethrower",
          "category": "ranged",
          "keywords": [
            "2-HANDED",
            "-1 INJURY DICE",
            "FIRE",
            "FLAMETHROWER",
            "IGNORE ARMOUR"
          ],
          "range": "8\"",
          "cost": 30,
          "costCurrency": "ducats",
          "limit": 3,
          "notes": ""
        },
        {
          "id": "synod_grenade_launcher",
          "templateName": "Grenade Launcher (Synod)",
          "name": "Grenade Launcher",
          "category": "ranged",
          "keywords": [
            "2-HANDED",
            "BLAST 3\"",
            "HEAVY",
            "IGNORE COVER",
            "SHRAPNEL"
          ],
          "range": "36\"",
          "cost": 30,
          "costCurrency": "ducats",
          "limit": 2,
          "notes": ""
        },
        {
          "id": "synod_heavy_flamethrower",
          "templateName": "Heavy Flamethrower (Synod)",
          "name": "Heavy Flamethrower",
          "category": "ranged",
          "keywords": [
            "2-HANDED",
            "-1 INJURY DICE",
            "AUTOMATIC 2",
            "FIRE",
            "FLAMETHROWER",
            "HEAVY",
            "IGNORE ARMOUR"
          ],
          "range": "10\"",
          "cost": 55,
          "costCurrency": "ducats",
          "limit": 1,
          "notes": ""
        },
        {
          "id": "synod_machine_gun",
          "templateName": "Machine Gun (Synod)",
          "name": "Machine Gun",
          "category": "ranged",
          "keywords": [
            "2-HANDED",
            "AUTOMATIC 3",
            "HEAVY",
            "RELOAD"
          ],
          "range": "36\"",
          "cost": 50,
          "costCurrency": "ducats",
          "limit": 1,
          "notes": ""
        },
        {
          "id": "synod_heavy_machine_pistol",
          "templateName": "Heavy Machine Pistol (Synod)",
          "name": "Heavy Machine Pistol",
          "category": "ranged",
          "keywords": [
            "2-HANDED",
            "AUTOMATIC 3",
            "HEAVY",
            "HELD",
            "SHOTGUN"
          ],
          "range": "20\"",
          "cost": 35,
          "costCurrency": "ducats",
          "limit": 1,
          "notes": ""
        },
        {
          "id": "synod_rpg",
          "templateName": "Rocket-Propelled Grenade (Synod)",
          "name": "Rocket-Propelled Grenade",
          "category": "ranged",
          "keywords": [
            "IGNORE ARMOUR",
            "+1 INJURY DICE",
            "RELOAD"
          ],
          "range": "24\"",
          "cost": 5,
          "costCurrency": "glory",
          "limit": 2,
          "notes": "Disposable Rocket: If a model hit by this weapon is not taken Out of Action by the Injury Roll, it is blown D6\" directly away from the attacker. Can only be used once per Battle."
        },
        {
          "id": "synod_pistol",
          "templateName": "Pistol (Synod)",
          "name": "Pistol",
          "category": "ranged",
          "keywords": [
            "1-HANDED",
            "PISTOL"
          ],
          "range": "12\"/Melee",
          "cost": 5,
          "costCurrency": "ducats",
          "notes": ""
        },
        {
          "id": "synod_semi_automatic_rifle",
          "templateName": "Semi-Automatic Rifle (Synod)",
          "name": "Semi-Automatic Rifle",
          "category": "ranged",
          "keywords": [
            "2-HANDED",
            "ASSAULT",
            "Bayonet Lug"
          ],
          "range": "24\"",
          "cost": 12,
          "costCurrency": "ducats",
          "notes": ""
        },
        {
          "id": "synod_shotgun",
          "templateName": "Shotgun (Synod)",
          "name": "Shotgun",
          "category": "ranged",
          "keywords": [
            "2-HANDED",
            "+1 DICE",
            "SHOTGUN",
            "Bayonet Lug",
            "Shield Combo"
          ],
          "range": "12\"",
          "cost": 10,
          "costCurrency": "ducats",
          "limit": 2,
          "notes": "Quick Bursts: Can take two Shoot ACTIONS in activation."
        },
        {
          "id": "synod_sniper_rifle",
          "templateName": "Sniper Rifle (Synod)",
          "name": "Sniper Rifle",
          "category": "ranged",
          "keywords": [
            "2-HANDED",
            "+1 DICE",
            "CRITICAL",
            "RISKY"
          ],
          "range": "48\"",
          "cost": 35,
          "costCurrency": "ducats",
          "limit": 3,
          "notes": "Bull's Eye: Critical Success Injury Roll gains IGNORE ARMOUR."
        },
        {
          "id": "synod_submachine_gun",
          "templateName": "Submachine Gun (Synod)",
          "name": "Submachine Gun",
          "category": "ranged",
          "keywords": [
            "2-HANDED",
            "ASSAULT",
            "Bayonet Lug",
            "Shield Combo"
          ],
          "range": "16\"",
          "cost": 30,
          "costCurrency": "ducats",
          "limit": 2,
          "notes": "Quick Bursts: Can take two Shoot ACTIONS in activation."
        },
        {
          "id": "synod_receptor_staff",
          "templateName": "Receptor Staff (Synod)",
          "name": "Receptor Staff",
          "category": "ranged",
          "keywords": [
            "1-HANDED",
            "+1 INJURY DICE",
            "HELD"
          ],
          "range": "18\"",
          "cost": 3,
          "costCurrency": "glory",
          "limit": 1,
          "restrictions": [
            "ELITE only"
          ],
          "notes": "Prophetic Imperative: When laying out your Prediction Cards at the start of the Turn, point at one and declare it blessed. When it resolves, if you were correct gain 2 Prophecy DICE. If you were wrong, the Enemy gets 1 Prophecy DICE."
        },
        {
          "id": "synod_softshell_shotgun",
          "templateName": "Softshell Shotgun (Synod)",
          "name": "Softshell Shotgun",
          "category": "ranged",
          "keywords": [
            "2-HANDED",
            "+3 INJURY DICE",
            "HEAVY",
            "SHOTGUN"
          ],
          "range": "12\"",
          "cost": 20,
          "costCurrency": "ducats",
          "limit": 2,
          "notes": "Overcharge: Any Armour Modifiers the enemy has are doubled before calculating Wound rolls inflicted by this Weapon (making any target with over 2 Armour unkillable)."
        },
        {
          "id": "synod_bayonet",
          "templateName": "Bayonet (Synod)",
          "name": "Bayonet",
          "category": "melee",
          "keywords": [
            "1-HANDED",
            "Shield Combo"
          ],
          "range": "Melee",
          "cost": 2,
          "costCurrency": "ducats",
          "notes": ""
        },
        {
          "id": "synod_great_hammer",
          "templateName": "Great Hammer/Maul (Synod)",
          "name": "Great Hammer/Maul",
          "category": "melee",
          "keywords": [
            "2-HANDED",
            "+1 INJURY MODIFIER",
            "HEAVY"
          ],
          "range": "Melee",
          "cost": 10,
          "costCurrency": "ducats",
          "notes": ""
        },
        {
          "id": "synod_great_sword",
          "templateName": "Great Sword/Axe (Synod)",
          "name": "Great Sword/Axe",
          "category": "melee",
          "keywords": [
            "2-HANDED",
            "+1 INJURY DICE",
            "CRITICAL",
            "HEAVY"
          ],
          "range": "Melee",
          "cost": 12,
          "costCurrency": "ducats",
          "notes": ""
        },
        {
          "id": "synod_angel_shard_spear",
          "templateName": "Angel Shard Spear (Synod)",
          "name": "Angel Shard Spear",
          "category": "melee",
          "keywords": [
            "2-HANDED",
            "+1 INJURY DICE"
          ],
          "range": "Melee",
          "cost": 25,
          "costCurrency": "ducats",
          "limit": 1,
          "restrictions": [
            "ELITE only"
          ],
          "notes": "Cast Down the Fallen: This weapon has the IGNORE ARMOUR Keyword if the target is Down."
        },
        {
          "id": "synod_polearm",
          "templateName": "Polearm (Synod)",
          "name": "Polearm",
          "category": "melee",
          "keywords": [
            "2-HANDED",
            "BLOCK",
            "CUMBERSOME",
            "Shield Combo"
          ],
          "range": "Melee",
          "cost": 7,
          "costCurrency": "ducats",
          "notes": ""
        },
        {
          "id": "synod_sword",
          "templateName": "Sword/Axe (Synod)",
          "name": "Sword/Axe",
          "category": "melee",
          "keywords": [
            "1-HANDED",
            "CRITICAL"
          ],
          "range": "Melee",
          "cost": 4,
          "costCurrency": "ducats",
          "notes": ""
        },
        {
          "id": "synod_trench_club",
          "templateName": "Trench Club (Synod)",
          "name": "Trench Club",
          "category": "melee",
          "keywords": [
            "1-HANDED"
          ],
          "range": "Melee",
          "cost": 3,
          "costCurrency": "ducats",
          "notes": ""
        },
        {
          "id": "synod_trench_knife",
          "templateName": "Trench Knife (Synod)",
          "name": "Trench Knife",
          "category": "melee",
          "keywords": [
            "1-HANDED",
            "-1 DICE"
          ],
          "range": "Melee",
          "cost": 1,
          "costCurrency": "ducats",
          "notes": ""
        },
        {
          "id": "synod_frag_grenade",
          "templateName": "Frag Grenades (Synod)",
          "name": "Frag Grenades",
          "category": "grenade",
          "keywords": [
            "ASSAULT",
            "BLAST 2\"",
            "IGNORE COVER",
            "IGNORE LONG RANGE",
            "SHRAPNEL"
          ],
          "range": "8\"",
          "cost": 7,
          "costCurrency": "ducats",
          "notes": ""
        },
        {
          "id": "synod_incendiary_grenade",
          "templateName": "Incendiary Grenades (Synod)",
          "name": "Incendiary Grenades",
          "category": "grenade",
          "keywords": [
            "ASSAULT",
            "FIRE",
            "IGNORE COVER",
            "IGNORE LONG RANGE"
          ],
          "range": "8\"",
          "cost": 10,
          "costCurrency": "ducats",
          "notes": "Liquid Fire: Critical Success Injury Roll gains IGNORE ARMOUR."
        },
        {
          "id": "synod_trench_shield",
          "templateName": "Trench Shield (Synod)",
          "name": "Trench Shield",
          "category": "shield",
          "keywords": [
            "Shield Combo"
          ],
          "armourModifier": "-1 INJURY MODIFIER",
          "cost": 10,
          "costCurrency": "ducats",
          "notes": ""
        },
        {
          "id": "synod_reinforced_armour",
          "templateName": "Reinforced Armour (Synod)",
          "name": "Reinforced Armour",
          "category": "armour",
          "keywords": [],
          "armourModifier": "-2 INJURY MODIFIER",
          "cost": 25,
          "costCurrency": "ducats",
          "restrictions": [
            "ELITE and Sanctified Heavy Infantry only"
          ],
          "notes": ""
        },
        {
          "id": "synod_standard_armour",
          "templateName": "Standard Armour (Synod)",
          "name": "Standard Armour",
          "category": "armour",
          "keywords": [],
          "armourModifier": "-1 INJURY MODIFIER",
          "cost": 15,
          "costCurrency": "ducats",
          "notes": ""
        },
        {
          "id": "synod_oculus_helmet",
          "templateName": "Oculus Helmet (Synod)",
          "name": "Oculus Helmet",
          "category": "equipment",
          "keywords": [],
          "cost": 2,
          "costCurrency": "glory",
          "restrictions": [
            "ELITE and Observer Initiate only"
          ],
          "notes": "Headgear. Eye of God: You can re-roll failed Success Rolls and Risky Success Rolls for a Model with this Helmet. If you do so and any of the re-rolled dice show a 1, then the roll is treated as a Failure, the model is taken Down, and their Activation immediately ends."
        },
        {
          "id": "synod_twice_blessed_bullets",
          "templateName": "Twice Blessed Bullets (Synod)",
          "name": "Twice Blessed Bullets",
          "category": "equipment",
          "keywords": [
            "AMMUNITION",
            "NEGATE CRITICAL"
          ],
          "cost": 10,
          "costCurrency": "ducats",
          "limit": 2,
          "restrictions": [
            "Cannot be used with Sniper Rifle"
          ],
          "notes": "Sanctified: A Success result of 9 or higher is converted into a Critical Hit."
        },
        {
          "id": "synod_binoculars",
          "templateName": "Binoculars (Synod)",
          "name": "Binoculars",
          "category": "equipment",
          "keywords": [],
          "cost": 10,
          "costCurrency": "ducats",
          "restrictions": [
            "ELITE only"
          ],
          "notes": "INFILTRATOR cannot deploy within 16\" unless in own zone."
        },
        {
          "id": "synod_combat_helmet",
          "templateName": "Combat Helmet (Synod)",
          "name": "Combat Helmet",
          "category": "equipment",
          "keywords": [
            "NEGATE SHRAPNEL"
          ],
          "cost": 25,
          "costCurrency": "ducats",
          "notes": "Headgear"
        },
        {
          "id": "synod_field_shrine",
          "templateName": "Field Shrine (Synod)",
          "name": "Field Shrine",
          "category": "equipment",
          "keywords": [],
          "cost": 2,
          "costCurrency": "glory",
          "notes": "Deploy terrain piece. +3 models for Morale (max +9). Can be attacked."
        },
        {
          "id": "synod_gas_mask",
          "templateName": "Gas Mask (Synod)",
          "name": "Gas Mask",
          "category": "equipment",
          "keywords": [
            "NEGATE GAS"
          ],
          "cost": 5,
          "costCurrency": "ducats",
          "notes": ""
        },
        {
          "id": "synod_medi_kit",
          "templateName": "Medi-kit (Synod)",
          "name": "Medi-kit",
          "category": "equipment",
          "keywords": [],
          "cost": 5,
          "costCurrency": "ducats",
          "notes": "Treat ACTION: Risky Success to remove BLOOD MARKER or stand up Down model within 1\"."
        },
        {
          "id": "synod_mountaineer_kit",
          "templateName": "Mountaineer Kit (Synod)",
          "name": "Mountaineer Kit",
          "category": "equipment",
          "keywords": [],
          "cost": 3,
          "costCurrency": "ducats",
          "limit": 4,
          "notes": "+1 DICE to climb sheer surfaces."
        },
        {
          "id": "synod_musical_instrument",
          "templateName": "Musical Instrument (Synod)",
          "name": "Musical Instrument",
          "category": "equipment",
          "keywords": [
            "HELD"
          ],
          "cost": 15,
          "costCurrency": "ducats",
          "limit": 1,
          "notes": "+1 DICE to Dash for friendly within 4\"."
        },
        {
          "id": "synod_shovel",
          "templateName": "Shovel (Synod)",
          "name": "Shovel",
          "category": "equipment",
          "keywords": [],
          "cost": 5,
          "costCurrency": "ducats",
          "notes": "COVER on Open terrain until move. Can use as 2-Handed Melee."
        },
        {
          "id": "synod_troop_flag",
          "templateName": "Troop Flag (Synod)",
          "name": "Troop Flag",
          "category": "equipment",
          "keywords": [
            "LEADER",
            "HELD"
          ],
          "cost": 1,
          "costCurrency": "glory",
          "limit": 1,
          "notes": ""
        },
        {
          "id": "synod_prophetic_revelation",
          "templateName": "Prophetic Revelation (Synod)",
          "name": "Prophetic Revelation",
          "category": "equipment",
          "keywords": [
            "CONSUMABLE"
          ],
          "cost": 1,
          "costCurrency": "glory",
          "notes": "Prophetic Revelation: Change the Frequency you chose when creating this Warband."
        }
      ]
    }
  }
];